/* @ds-bundle: {"format":3,"namespace":"CarrTechAIDesignSystem_ad3660","components":[{"name":"Badge","sourcePath":"components/core/Badge.jsx"},{"name":"Button","sourcePath":"components/core/Button.jsx"},{"name":"Card","sourcePath":"components/core/Card.jsx"},{"name":"Compass","sourcePath":"components/core/Compass.jsx"},{"name":"IconButton","sourcePath":"components/core/IconButton.jsx"},{"name":"Kicker","sourcePath":"components/core/Kicker.jsx"},{"name":"Logo","sourcePath":"components/core/Logo.jsx"},{"name":"StatusPill","sourcePath":"components/core/StatusPill.jsx"},{"name":"Tag","sourcePath":"components/core/Tag.jsx"},{"name":"ActivityItem","sourcePath":"components/data/ActivityItem.jsx"},{"name":"StatCard","sourcePath":"components/data/StatCard.jsx"},{"name":"Table","sourcePath":"components/data/Table.jsx"},{"name":"Dialog","sourcePath":"components/feedback/Dialog.jsx"},{"name":"ProgressBar","sourcePath":"components/feedback/ProgressBar.jsx"},{"name":"Spinner","sourcePath":"components/feedback/Spinner.jsx"},{"name":"Toast","sourcePath":"components/feedback/Toast.jsx"},{"name":"Tooltip","sourcePath":"components/feedback/Tooltip.jsx"},{"name":"Checkbox","sourcePath":"components/forms/Checkbox.jsx"},{"name":"Input","sourcePath":"components/forms/Input.jsx"},{"name":"Radio","sourcePath":"components/forms/Radio.jsx"},{"name":"Select","sourcePath":"components/forms/Select.jsx"},{"name":"Switch","sourcePath":"components/forms/Switch.jsx"},{"name":"Textarea","sourcePath":"components/forms/Textarea.jsx"},{"name":"Avatar","sourcePath":"components/navigation/Avatar.jsx"},{"name":"SidebarItem","sourcePath":"components/navigation/SidebarItem.jsx"},{"name":"Tabs","sourcePath":"components/navigation/Tabs.jsx"}],"sourceHashes":{"components/core/Badge.jsx":"355ee2cfb493","components/core/Button.jsx":"2b724b2558e0","components/core/Card.jsx":"761f583b5d3b","components/core/Compass.jsx":"3670e148b385","components/core/IconButton.jsx":"622958840868","components/core/Kicker.jsx":"a0652de7ed25","components/core/Logo.jsx":"7e3d40989db4","components/core/StatusPill.jsx":"971e8d77cc4d","components/core/Tag.jsx":"a0db233a59d5","components/data/ActivityItem.jsx":"682d3fc67505","components/data/StatCard.jsx":"c2764b153bad","components/data/Table.jsx":"bf26874214ac","components/feedback/Dialog.jsx":"2412bff1b412","components/feedback/ProgressBar.jsx":"4bcab7f40cf2","components/feedback/Spinner.jsx":"2cbcc8250924","components/feedback/Toast.jsx":"72e33f05422b","components/feedback/Tooltip.jsx":"f090d2a1f8b0","components/forms/Checkbox.jsx":"feb821598e84","components/forms/Input.jsx":"bda13457fa7b","components/forms/Radio.jsx":"91b6fe4dfaff","components/forms/Select.jsx":"dc07cbce9b65","components/forms/Switch.jsx":"c7d7b64aa88d","components/forms/Textarea.jsx":"1b70eeb94af5","components/navigation/Avatar.jsx":"28a9ba377c26","components/navigation/SidebarItem.jsx":"ab7d93a2f155","components/navigation/Tabs.jsx":"713726a2a2bf","ui_kits/mission-control/data.js":"7bb9123bc466","ui_kits/mission-control/icons.jsx":"5a838c93c31f","ui_kits/mission-control/mc-widgets.jsx":"132ae0577e81","ui_kits/mission-control/tweaks-panel.jsx":"6591467622ed"},"inlinedExternals":[],"unexposedExports":[]} */

(() => {

const __ds_ns = (window.CarrTechAIDesignSystem_ad3660 = window.CarrTechAIDesignSystem_ad3660 || {});

const __ds_scope = {};

(__ds_ns.__errors = __ds_ns.__errors || []);

// components/core/Badge.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const TONES = {
  neutral: {
    color: 'var(--muted)',
    background: 'var(--surface2)',
    border: 'var(--border)'
  },
  iris: {
    color: 'var(--primary)',
    background: 'var(--primary-soft)',
    border: 'var(--primary-line)'
  },
  cyan: {
    color: 'var(--accent-ink)',
    background: 'var(--accent-soft)',
    border: 'var(--accent-line)'
  },
  warn: {
    color: 'var(--warn)',
    background: 'var(--warn-soft)',
    border: 'var(--warn-line)'
  },
  danger: {
    color: 'var(--danger)',
    background: 'var(--danger-soft)',
    border: 'var(--danger-line)'
  }
};

/**
 * Small label or count — counts, versions, inline states. Five brand tones
 * (neutral / iris / cyan / warn / danger). Set mono for a JetBrains-Mono count
 * chip (e.g. build numbers, diff counts).
 */
function Badge({
  tone = 'neutral',
  mono = false,
  children,
  style,
  ...rest
}) {
  const t = TONES[tone] || TONES.neutral;
  return /*#__PURE__*/React.createElement("span", _extends({
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: 6,
      padding: '3px 9px',
      borderRadius: 'var(--radius-pill)',
      fontFamily: mono ? 'var(--font-mono)' : 'var(--font-heading)',
      fontSize: mono ? 'var(--text-micro)' : 12,
      fontWeight: 600,
      letterSpacing: mono ? '0.04em' : 0,
      lineHeight: 1.4,
      color: t.color,
      background: t.background,
      border: `1px solid ${t.border}`,
      ...style
    }
  }, rest), children);
}
Object.assign(__ds_scope, { Badge });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/Badge.jsx", error: String((e && e.message) || e) }); }

// components/core/Button.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SIZES = {
  sm: {
    padding: '9px 16px',
    fontSize: 14,
    radius: 'var(--radius-md)'
  },
  md: {
    padding: '13px 22px',
    fontSize: 15.5,
    radius: 'var(--radius-md)'
  },
  lg: {
    padding: '15px 26px',
    fontSize: 16,
    radius: 14
  }
};
function variantStyle(v, hover, disabled) {
  const lift = hover && !disabled;
  switch (v) {
    case 'secondary':
      return {
        background: lift ? 'var(--surface)' : 'transparent',
        color: 'var(--ink)',
        borderColor: lift ? 'var(--primary)' : 'var(--border)',
        fontWeight: 500
      };
    case 'ghost':
      return {
        background: lift ? 'var(--surface2)' : 'transparent',
        color: 'var(--ink)',
        fontWeight: 500
      };
    case 'danger':
      return {
        background: 'var(--danger-soft)',
        color: 'var(--danger)',
        borderColor: 'var(--danger-line)'
      };
    case 'primary':
    default:
      return {
        background: 'var(--primary)',
        color: 'var(--on-primary)',
        boxShadow: '0 0 0 1px var(--primary-line), 0 12px 34px -12px var(--glow-iris)',
        filter: lift ? 'brightness(1.06)' : 'none'
      };
  }
}

/**
 * Primary action button. Iris fill is the primary CTA; secondary is a hairline
 * ghost, ghost is chrome-less, danger is a soft-coral destructive. Space Grotesk
 * 600, rounded, a 1px lift on hover. Pass iconLeft/iconRight for line icons.
 */
function Button({
  variant = 'primary',
  size = 'md',
  disabled = false,
  full = false,
  iconLeft = null,
  iconRight = null,
  type = 'button',
  onClick,
  children,
  style,
  ...rest
}) {
  const [hover, setHover] = React.useState(false);
  const sz = SIZES[size] || SIZES.md;
  return /*#__PURE__*/React.createElement("button", _extends({
    type: type,
    disabled: disabled,
    onClick: onClick,
    onMouseEnter: () => setHover(true),
    onMouseLeave: () => setHover(false),
    style: {
      display: full ? 'flex' : 'inline-flex',
      width: full ? '100%' : undefined,
      alignItems: 'center',
      justifyContent: 'center',
      gap: 9,
      fontFamily: 'var(--font-heading)',
      fontWeight: 600,
      lineHeight: 1,
      cursor: disabled ? 'not-allowed' : 'pointer',
      border: '1px solid transparent',
      borderRadius: sz.radius,
      padding: sz.padding,
      fontSize: sz.fontSize,
      opacity: disabled ? 0.5 : 1,
      transform: hover && !disabled ? 'translateY(-1px)' : 'none',
      transition: 'transform var(--dur) var(--ease), filter var(--dur) ease, background var(--dur) ease, border-color var(--dur) ease',
      ...variantStyle(variant, hover, disabled),
      ...style
    }
  }, rest), iconLeft, children, iconRight);
}
Object.assign(__ds_scope, { Button });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/Button.jsx", error: String((e && e.message) || e) }); }

// components/core/Card.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Surface container — the workhorse panel for every Mission Control view.
 * `default` is a flat surface; `feature` carries the iris→cyan gradient wash;
 * `raised` sits one step lighter. `glow` adds a cyan edge + drop for the one
 * crew/active card per view; `interactive` lifts on hover for clickable cards.
 */
function Card({
  variant = 'default',
  interactive = false,
  glow = false,
  style,
  children,
  ...rest
}) {
  const [hover, setHover] = React.useState(false);
  const variants = {
    default: {
      background: 'var(--surface)'
    },
    feature: {
      background: 'var(--card-grad)'
    },
    raised: {
      background: 'var(--surface2)'
    }
  };
  const v = variants[variant] || variants.default;
  const lift = interactive && hover;
  return /*#__PURE__*/React.createElement("div", _extends({
    onMouseEnter: () => setHover(true),
    onMouseLeave: () => setHover(false),
    style: {
      position: 'relative',
      borderRadius: 'var(--radius-xl)',
      padding: 'var(--space-6)',
      border: '1px solid var(--border)',
      borderColor: glow ? 'var(--accent-line)' : lift ? 'var(--primary-line)' : 'var(--border)',
      boxShadow: glow ? '0 18px 50px -30px var(--glow-cyan)' : undefined,
      transform: lift ? 'translateY(-2px)' : 'none',
      transition: 'transform var(--dur) var(--ease), border-color var(--dur) ease',
      ...v,
      ...style
    }
  }, rest), children);
}
Object.assign(__ds_scope, { Card });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/Card.jsx", error: String((e && e.message) || e) }); }

// components/core/Compass.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * The CarrTech.AI compass mark — a faceted rose: one iris North (the human
 * setting the bearing) leading three cyan crew points (the AI crew). North
 * always leads; built from primitives, never freehand. Colors come from the
 * theme (--primary / --accent / --ink) so it adapts to dark and light.
 */
function Compass({
  size = 28,
  glow = false,
  className,
  style,
  ...rest
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 64 64",
    fill: "none",
    "aria-hidden": "true",
    focusable: "false",
    className: className,
    style: {
      flex: 'none',
      filter: glow ? 'drop-shadow(0 0 9px var(--glow-iris))' : undefined,
      ...style
    }
  }, rest), /*#__PURE__*/React.createElement("circle", {
    cx: "32",
    cy: "32",
    r: "28.3",
    stroke: "var(--ink)",
    strokeOpacity: "0.16",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "var(--ink)",
    strokeOpacity: "0.28",
    strokeWidth: "2",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: "32",
    y1: "3.6",
    x2: "32",
    y2: "8.2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "32",
    y1: "55.8",
    x2: "32",
    y2: "60.4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "3.6",
    y1: "32",
    x2: "8.2",
    y2: "32"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "55.8",
    y1: "32",
    x2: "60.4",
    y2: "32"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51 32 L36.60 27.40 L32 32 Z",
    fill: "var(--accent)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 32 L36.60 36.60 L32 32 Z",
    fill: "var(--accent)",
    fillOpacity: "0.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 32 L27.40 36.60 L32 32 Z",
    fill: "var(--accent)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 32 L27.40 27.40 L32 32 Z",
    fill: "var(--accent)",
    fillOpacity: "0.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 51 L36.60 36.60 L32 32 Z",
    fill: "var(--accent)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 51 L27.40 36.60 L32 32 Z",
    fill: "var(--accent)",
    fillOpacity: "0.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 10.5 L36.60 27.40 L32 32 Z",
    fill: "var(--primary)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 10.5 L27.40 27.40 L32 32 Z",
    fill: "var(--primary)",
    fillOpacity: "0.72"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "32",
    cy: "32",
    r: "2.4",
    fill: "var(--ink)"
  }));
}
Object.assign(__ds_scope, { Compass });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/Compass.jsx", error: String((e && e.message) || e) }); }

// components/core/IconButton.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const IB_SIZES = {
  sm: 32,
  md: 38,
  lg: 44
};

/**
 * Square icon button — toolbar actions, theme toggles, overflow menus. Houses a
 * single line icon (pass as children). Default is a bordered surface that picks
 * up an iris edge on hover; primary and ghost variants available.
 */
function IconButton({
  size = 'md',
  variant = 'default',
  label,
  disabled = false,
  active = false,
  onClick,
  children,
  style,
  ...rest
}) {
  const [hover, setHover] = React.useState(false);
  const dim = IB_SIZES[size] || IB_SIZES.md;
  const variants = {
    default: {
      background: 'var(--surface)',
      color: 'var(--ink)',
      borderColor: hover || active ? 'var(--primary)' : 'var(--border)'
    },
    primary: {
      background: 'var(--primary)',
      color: 'var(--on-primary)',
      borderColor: 'var(--primary-line)'
    },
    ghost: {
      background: hover || active ? 'var(--surface2)' : 'transparent',
      color: active ? 'var(--ink)' : 'var(--muted)',
      borderColor: 'transparent'
    }
  };
  return /*#__PURE__*/React.createElement("button", _extends({
    type: "button",
    "aria-label": label,
    title: label,
    disabled: disabled,
    onClick: onClick,
    onMouseEnter: () => setHover(true),
    onMouseLeave: () => setHover(false),
    style: {
      width: dim,
      height: dim,
      flex: 'none',
      display: 'grid',
      placeItems: 'center',
      borderRadius: 'var(--radius-md)',
      border: '1px solid transparent',
      cursor: disabled ? 'not-allowed' : 'pointer',
      opacity: disabled ? 0.5 : 1,
      transition: 'border-color var(--dur) ease, background var(--dur) ease, color var(--dur) ease',
      ...variants[variant],
      ...style
    }
  }, rest), children);
}
Object.assign(__ds_scope, { IconButton });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/IconButton.jsx", error: String((e && e.message) || e) }); }

// components/core/Kicker.jsx
try { (() => {
/**
 * The "// section" eyebrow — tracked uppercase JetBrains Mono. The brand's
 * signature label; include the literal "// " prefix in the text. Cyan ink by
 * default (AA-safe), or muted for quieter labels.
 */
function Kicker({
  tone = 'cyan',
  as = 'div',
  children,
  style,
  ...rest
}) {
  const color = tone === 'muted' ? 'var(--muted)' : 'var(--accent-ink)';
  return React.createElement(as, {
    style: {
      fontFamily: 'var(--font-mono)',
      fontSize: 'var(--text-label)',
      fontWeight: 500,
      letterSpacing: 'var(--tracking-label)',
      textTransform: 'uppercase',
      color,
      ...style
    },
    ...rest
  }, children);
}
Object.assign(__ds_scope, { Kicker });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/Kicker.jsx", error: String((e && e.message) || e) }); }

// components/core/Logo.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * The CarrTech.AI lockup — compass mark + "CarrTech.AI" wordmark (.AI stays
 * iris). Use in nav, sidebars, footers. Horizontal or stacked; an optional
 * mono tag (e.g. "mission control") sits after a hairline divider.
 */
function Logo({
  size = 28,
  orientation = 'horizontal',
  wordmark = true,
  tag,
  glow = true,
  style,
  ...rest
}) {
  const stacked = orientation === 'stacked';
  return /*#__PURE__*/React.createElement("span", _extends({
    style: {
      display: 'inline-flex',
      flexDirection: stacked ? 'column' : 'row',
      alignItems: 'center',
      gap: stacked ? 8 : 11,
      color: 'var(--ink)',
      textDecoration: 'none',
      ...style
    }
  }, rest), /*#__PURE__*/React.createElement(__ds_scope.Compass, {
    size: size,
    glow: glow
  }), wordmark && /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-heading)',
      fontWeight: 600,
      fontSize: Math.round(size * 0.64),
      letterSpacing: '-0.01em',
      lineHeight: 1
    }
  }, "CarrTech", /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'var(--primary)'
    }
  }, ".AI")), tag && /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-mono)',
      fontSize: 11,
      color: 'var(--muted)',
      marginLeft: stacked ? 0 : 4,
      paddingLeft: stacked ? 0 : 11,
      borderLeft: stacked ? 'none' : '1px solid var(--border)'
    }
  }, tag));
}
Object.assign(__ds_scope, { Logo });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/Logo.jsx", error: String((e && e.message) || e) }); }

// components/core/StatusPill.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* Project + build lifecycle states. Live & running pulse; just-a-spark is a
   dashed outline. Cyan = shipped/live signal, iris = active human/crew work,
   amber = running/attention, coral = failed, muted = early ideas. */
const STATUS = {
  live: {
    label: 'Live',
    color: 'var(--accent-ink)',
    bg: 'var(--accent-soft)',
    line: 'var(--accent-line)',
    pulse: true
  },
  'in-the-workshop': {
    label: 'In the workshop',
    color: 'var(--primary)',
    bg: 'var(--primary-soft)',
    line: 'var(--primary-line)'
  },
  'on-the-whiteboard': {
    label: 'On the whiteboard',
    color: 'var(--muted)',
    bg: 'var(--surface2)',
    line: 'var(--border)'
  },
  'just-a-spark': {
    label: 'Just a spark',
    color: 'var(--muted)',
    bg: 'transparent',
    line: 'var(--border)',
    dash: true
  },
  running: {
    label: 'Running',
    color: 'var(--primary)',
    bg: 'var(--primary-soft)',
    line: 'var(--primary-line)',
    pulse: true
  },
  passed: {
    label: 'Passed',
    color: 'var(--accent-ink)',
    bg: 'var(--accent-soft)',
    line: 'var(--accent-line)'
  },
  failed: {
    label: 'Failed',
    color: 'var(--danger)',
    bg: 'var(--danger-soft)',
    line: 'var(--danger-line)'
  },
  queued: {
    label: 'Queued',
    color: 'var(--muted)',
    bg: 'var(--surface2)',
    line: 'var(--border)'
  },
  // Agent run states
  idle: {
    label: 'Idle',
    color: 'var(--muted)',
    bg: 'var(--surface2)',
    line: 'var(--border)'
  },
  blocked: {
    label: 'Blocked',
    color: 'var(--warn)',
    bg: 'var(--warn-soft)',
    line: 'var(--warn-line)'
  },
  errored: {
    label: 'Errored',
    color: 'var(--danger)',
    bg: 'var(--danger-soft)',
    line: 'var(--danger-line)'
  }
};

/**
 * Status pill — the data-driven lifecycle indicator from the studio's build-in-
 * public contract. Status drives color, label, and whether the dot pulses;
 * override the text with `label`.
 */
function StatusPill({
  status = 'live',
  label,
  dot = true,
  style,
  ...rest
}) {
  const s = STATUS[status] || STATUS.live;
  return /*#__PURE__*/React.createElement("span", _extends({
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: 6,
      padding: '5px 11px',
      borderRadius: 'var(--radius-pill)',
      fontFamily: 'var(--font-mono)',
      fontSize: 'var(--text-micro)',
      fontWeight: 500,
      letterSpacing: '0.08em',
      textTransform: 'uppercase',
      color: s.color,
      background: s.bg,
      border: `1px ${s.dash ? 'dashed' : 'solid'} ${s.line}`,
      whiteSpace: 'nowrap',
      ...style
    }
  }, rest), dot && /*#__PURE__*/React.createElement("span", {
    style: {
      width: 6,
      height: 6,
      borderRadius: '50%',
      background: 'currentColor',
      flex: 'none',
      animation: s.pulse ? 'ct-pulse 2s ease-in-out infinite' : undefined
    }
  }), label || s.label);
}
Object.assign(__ds_scope, { StatusPill });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/StatusPill.jsx", error: String((e && e.message) || e) }); }

// components/core/Tag.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const TAG_TONES = {
  neutral: {
    color: 'var(--muted)',
    bg: 'var(--surface2)',
    line: 'var(--border)'
  },
  iris: {
    color: 'var(--primary)',
    bg: 'var(--primary-soft)',
    line: 'var(--primary-line)'
  },
  cyan: {
    color: 'var(--accent-ink)',
    bg: 'var(--accent-soft)',
    line: 'var(--accent-line)'
  }
};

/**
 * Mono chip — capability tags, filters, metadata (e.g. "websites", "design",
 * "research"). JetBrains Mono, pill-shaped, three brand tones. Pair with a
 * leading marker via children if you want the cyan "· " accent.
 */
function Tag({
  tone = 'neutral',
  children,
  style,
  ...rest
}) {
  const t = TAG_TONES[tone] || TAG_TONES.neutral;
  return /*#__PURE__*/React.createElement("span", _extends({
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: 7,
      fontFamily: 'var(--font-mono)',
      fontSize: 'var(--text-label)',
      fontWeight: 500,
      padding: '7px 14px',
      borderRadius: 'var(--radius-pill)',
      color: t.color,
      background: t.bg,
      border: `1px solid ${t.line}`,
      ...style
    }
  }, rest), children);
}
Object.assign(__ds_scope, { Tag });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/Tag.jsx", error: String((e && e.message) || e) }); }

// components/data/ActivityItem.jsx
try { (() => {
const TONES = {
  iris: 'var(--primary)',
  cyan: 'var(--accent)',
  warn: 'var(--warn)',
  danger: 'var(--danger)',
  muted: 'var(--muted)'
};

/**
 * Activity-feed row — a timeline entry for the crew's live stream. A tone dot on
 * a connector rail, then title + meta + time. Set `last` on the final row to stop
 * the rail. The "alive" Mission Control primitive.
 */
function ActivityItem({
  title,
  meta,
  time,
  tone = 'iris',
  last = false,
  icon,
  style
}) {
  const color = TONES[tone] || TONES.iris;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      gap: 13,
      ...style
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      flex: 'none'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      width: 11,
      height: 11,
      borderRadius: '50%',
      marginTop: 4,
      background: icon ? 'var(--surface)' : color,
      border: icon ? `1px solid ${color}` : '2px solid var(--bg)',
      boxShadow: `0 0 8px ${color}`,
      display: 'grid',
      placeItems: 'center',
      color
    }
  }, icon), !last && /*#__PURE__*/React.createElement("span", {
    style: {
      flex: 1,
      width: 1.5,
      background: 'var(--border)',
      marginTop: 3,
      minHeight: 16
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      paddingBottom: last ? 0 : 16,
      flex: 1,
      minWidth: 0
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 14,
      color: 'var(--ink)',
      lineHeight: 1.45
    }
  }, title), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      gap: 8,
      alignItems: 'center',
      marginTop: 3,
      fontFamily: 'var(--font-mono)',
      fontSize: 11,
      color: 'var(--muted)'
    }
  }, meta && /*#__PURE__*/React.createElement("span", null, meta), meta && time && /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true"
  }, "\xB7"), time && /*#__PURE__*/React.createElement("span", null, time))));
}
Object.assign(__ds_scope, { ActivityItem });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/data/ActivityItem.jsx", error: String((e && e.message) || e) }); }

// components/data/StatCard.jsx
try { (() => {
/**
 * Metric tile — a labelled KPI with a big Space Grotesk value and an optional
 * delta. Self-contained surface; drop several in a grid for the Mission Control
 * overview. `deltaTone` colors the change chip (cyan up, coral down, muted flat).
 */
function StatCard({
  label,
  value,
  unit,
  delta,
  deltaTone = 'cyan',
  icon,
  style
}) {
  const tones = {
    cyan: {
      color: 'var(--accent-ink)',
      bg: 'var(--accent-soft)',
      line: 'var(--accent-line)'
    },
    iris: {
      color: 'var(--primary)',
      bg: 'var(--primary-soft)',
      line: 'var(--primary-line)'
    },
    danger: {
      color: 'var(--danger)',
      bg: 'var(--danger-soft)',
      line: 'var(--danger-line)'
    },
    muted: {
      color: 'var(--muted)',
      bg: 'var(--surface2)',
      line: 'var(--border)'
    }
  };
  const t = tones[deltaTone] || tones.cyan;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative',
      borderRadius: 'var(--radius-lg)',
      padding: '18px 20px',
      background: 'var(--surface)',
      border: '1px solid var(--border)',
      ...style
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: 14
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-mono)',
      fontSize: 11,
      letterSpacing: '0.08em',
      textTransform: 'uppercase',
      color: 'var(--muted)'
    }
  }, label), icon && /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'flex',
      color: 'var(--muted)'
    }
  }, icon)), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'baseline',
      gap: 8,
      flexWrap: 'wrap'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-heading)',
      fontWeight: 600,
      fontSize: 30,
      lineHeight: 1,
      letterSpacing: '-0.02em',
      color: 'var(--ink)'
    }
  }, value), unit && /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-mono)',
      fontSize: 12,
      color: 'var(--muted)'
    }
  }, unit), delta != null && /*#__PURE__*/React.createElement("span", {
    style: {
      marginLeft: 'auto',
      fontFamily: 'var(--font-mono)',
      fontSize: 11,
      fontWeight: 600,
      padding: '3px 8px',
      borderRadius: 999,
      color: t.color,
      background: t.bg,
      border: `1px solid ${t.line}`
    }
  }, delta)));
}
Object.assign(__ds_scope, { StatCard });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/data/StatCard.jsx", error: String((e && e.message) || e) }); }

// components/data/Table.jsx
try { (() => {
/**
 * Lightweight data table. `columns` is [{ key, label, align?, width?, render? }];
 * `rows` is an array of objects. Mono uppercase headers, hairline row dividers,
 * a subtle hover. Use `render(row)` to drop a StatusPill or Badge into a cell.
 */
function Table({
  columns = [],
  rows = [],
  style
}) {
  const [hover, setHover] = React.useState(-1);
  return /*#__PURE__*/React.createElement("table", {
    style: {
      width: '100%',
      borderCollapse: 'collapse',
      fontFamily: 'var(--font-body)',
      ...style
    }
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, columns.map(c => /*#__PURE__*/React.createElement("th", {
    key: c.key,
    style: {
      textAlign: c.align || 'left',
      width: c.width,
      padding: '0 14px 10px',
      fontFamily: 'var(--font-mono)',
      fontSize: 10.5,
      fontWeight: 500,
      letterSpacing: '0.08em',
      textTransform: 'uppercase',
      color: 'var(--muted)',
      whiteSpace: 'nowrap'
    }
  }, c.label)))), /*#__PURE__*/React.createElement("tbody", null, rows.map((r, i) => /*#__PURE__*/React.createElement("tr", {
    key: r.id ?? i,
    onMouseEnter: () => setHover(i),
    onMouseLeave: () => setHover(-1),
    style: {
      background: hover === i ? 'var(--surface2)' : 'transparent',
      transition: 'background var(--dur-fast) ease'
    }
  }, columns.map(c => /*#__PURE__*/React.createElement("td", {
    key: c.key,
    style: {
      textAlign: c.align || 'left',
      padding: '12px 14px',
      borderTop: '1px solid var(--border)',
      fontSize: 14,
      color: 'var(--ink)',
      verticalAlign: 'middle'
    }
  }, c.render ? c.render(r) : r[c.key]))))));
}
Object.assign(__ds_scope, { Table });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/data/Table.jsx", error: String((e && e.message) || e) }); }

// components/feedback/Dialog.jsx
try { (() => {
/**
 * Modal dialog — fixed, centered, on a blurred scrim. Controlled via `open`;
 * `onClose` fires on scrim click and the close button. Put action Buttons in
 * `footer`. Click inside the panel does not close it.
 */
function Dialog({
  open = false,
  title,
  children,
  footer,
  onClose,
  width = 480
}) {
  if (!open) return null;
  return /*#__PURE__*/React.createElement("div", {
    onClick: onClose,
    style: {
      position: 'fixed',
      inset: 0,
      zIndex: 'var(--z-overlay)',
      display: 'grid',
      placeItems: 'center',
      background: 'rgba(5, 7, 12, 0.6)',
      backdropFilter: 'blur(4px)',
      WebkitBackdropFilter: 'blur(4px)',
      padding: 20
    }
  }, /*#__PURE__*/React.createElement("div", {
    onClick: e => e.stopPropagation(),
    role: "dialog",
    "aria-modal": "true",
    style: {
      width,
      maxWidth: '100%',
      background: 'var(--surface)',
      border: '1px solid var(--border)',
      borderRadius: 'var(--radius-2xl)',
      boxShadow: 'var(--shadow)',
      overflow: 'hidden'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      gap: 16,
      padding: '22px 22px 0'
    }
  }, title && /*#__PURE__*/React.createElement("h3", {
    style: {
      fontFamily: 'var(--font-heading)',
      fontWeight: 600,
      fontSize: 19,
      margin: 0,
      color: 'var(--ink)'
    }
  }, title), onClose && /*#__PURE__*/React.createElement("button", {
    onClick: onClose,
    "aria-label": "Close",
    style: {
      flex: 'none',
      background: 'none',
      border: 'none',
      color: 'var(--muted)',
      cursor: 'pointer',
      padding: 2,
      lineHeight: 0,
      marginTop: 2
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 6 6 18M6 6l12 12"
  })))), /*#__PURE__*/React.createElement("div", {
    style: {
      padding: '12px 22px 0',
      color: 'var(--muted)',
      fontSize: 14.5,
      lineHeight: 1.6
    }
  }, children), footer && /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'flex-end',
      gap: 10,
      padding: 22,
      marginTop: 8
    }
  }, footer), !footer && /*#__PURE__*/React.createElement("div", {
    style: {
      height: 22
    }
  })));
}
Object.assign(__ds_scope, { Dialog });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/feedback/Dialog.jsx", error: String((e && e.message) || e) }); }

// components/feedback/ProgressBar.jsx
try { (() => {
/**
 * Progress bar. Determinate when `value` (0–100) is set; omit it for an
 * indeterminate sweep. Iris or cyan fill with a soft glow.
 */
function ProgressBar({
  value = null,
  tone = 'primary',
  height = 6,
  label,
  style
}) {
  const color = tone === 'cyan' ? 'var(--accent)' : 'var(--primary)';
  const glow = tone === 'cyan' ? 'var(--glow-cyan)' : 'var(--glow-iris)';
  const indet = value == null;
  const pct = indet ? 0 : Math.max(0, Math.min(100, value));
  return /*#__PURE__*/React.createElement("div", {
    style: {
      width: '100%',
      ...style
    }
  }, label && /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'space-between',
      fontFamily: 'var(--font-mono)',
      fontSize: 11,
      color: 'var(--muted)',
      marginBottom: 6
    }
  }, /*#__PURE__*/React.createElement("span", null, label), !indet && /*#__PURE__*/React.createElement("span", null, Math.round(pct), "%")), /*#__PURE__*/React.createElement("div", {
    style: {
      height,
      borderRadius: 999,
      background: 'var(--surface2)',
      overflow: 'hidden',
      position: 'relative'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: indet ? 'absolute' : 'relative',
      top: 0,
      height: '100%',
      borderRadius: 999,
      background: color,
      width: indet ? '40%' : `${pct}%`,
      boxShadow: `0 0 12px ${glow}`,
      transition: indet ? undefined : 'width var(--dur-slow) var(--ease)',
      animation: indet ? 'ct-prog 1.4s ease-in-out infinite' : undefined
    }
  })));
}
Object.assign(__ds_scope, { ProgressBar });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/feedback/ProgressBar.jsx", error: String((e && e.message) || e) }); }

// components/feedback/Spinner.jsx
try { (() => {
/** Spinning ring loader. Iris by default; cyan/muted variants. */
function Spinner({
  size = 20,
  tone = 'primary',
  label = 'Loading',
  style
}) {
  const color = tone === 'cyan' ? 'var(--accent)' : tone === 'muted' ? 'var(--muted)' : 'var(--primary)';
  const bw = Math.max(2, Math.round(size / 10));
  return /*#__PURE__*/React.createElement("span", {
    role: "status",
    "aria-label": label,
    style: {
      display: 'inline-block',
      width: size,
      height: size,
      borderRadius: '50%',
      border: `${bw}px solid var(--surface2)`,
      borderTopColor: color,
      animation: 'ct-spin 0.7s linear infinite',
      ...style
    }
  });
}
Object.assign(__ds_scope, { Spinner });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/feedback/Spinner.jsx", error: String((e && e.message) || e) }); }

// components/feedback/Toast.jsx
try { (() => {
const TONES = {
  info: {
    color: 'var(--primary)',
    soft: 'var(--primary-soft)',
    line: 'var(--primary-line)'
  },
  success: {
    color: 'var(--accent-ink)',
    soft: 'var(--accent-soft)',
    line: 'var(--accent-line)'
  },
  warn: {
    color: 'var(--warn)',
    soft: 'var(--warn-soft)',
    line: 'var(--warn-line)'
  },
  danger: {
    color: 'var(--danger)',
    soft: 'var(--danger-soft)',
    line: 'var(--danger-line)'
  }
};
const DEFAULT_ICON = {
  info: /*#__PURE__*/React.createElement("path", {
    d: "M12 16v-4M12 8h.01"
  }),
  success: /*#__PURE__*/React.createElement("path", {
    d: "M20 6 9 17l-5-5"
  }),
  warn: /*#__PURE__*/React.createElement("path", {
    d: "M12 9v4M12 17h.01M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z"
  }),
  danger: /*#__PURE__*/React.createElement("path", {
    d: "M18 6 6 18M6 6l12 12"
  })
};

/**
 * Toast notification — a surface chip with a tone-colored icon (not a colored
 * border), a title, optional message, and a dismiss. Render in a stack in a
 * fixed corner; tone sets the icon color.
 */
function Toast({
  tone = 'info',
  title,
  children,
  onClose,
  icon,
  style
}) {
  const t = TONES[tone] || TONES.info;
  return /*#__PURE__*/React.createElement("div", {
    role: "status",
    style: {
      display: 'flex',
      gap: 12,
      alignItems: 'flex-start',
      width: 340,
      maxWidth: '100%',
      padding: '13px 14px',
      borderRadius: 'var(--radius-md)',
      background: 'var(--surface)',
      border: '1px solid var(--border)',
      boxShadow: 'var(--shadow)',
      ...style
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      flex: 'none',
      width: 30,
      height: 30,
      borderRadius: 9,
      display: 'grid',
      placeItems: 'center',
      background: t.soft,
      border: `1px solid ${t.line}`,
      color: t.color
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2.2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, icon || DEFAULT_ICON[tone] || DEFAULT_ICON.info)), /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1,
      minWidth: 0
    }
  }, title && /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: 'var(--font-heading)',
      fontWeight: 600,
      fontSize: 14,
      color: 'var(--ink)',
      marginBottom: children ? 2 : 0
    }
  }, title), children && /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 13,
      lineHeight: 1.5,
      color: 'var(--muted)'
    }
  }, children)), onClose && /*#__PURE__*/React.createElement("button", {
    onClick: onClose,
    "aria-label": "Dismiss",
    style: {
      flex: 'none',
      background: 'none',
      border: 'none',
      color: 'var(--muted)',
      cursor: 'pointer',
      padding: 2,
      lineHeight: 0
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 6 6 18M6 6l12 12"
  }))));
}
Object.assign(__ds_scope, { Toast });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/feedback/Toast.jsx", error: String((e && e.message) || e) }); }

// components/feedback/Tooltip.jsx
try { (() => {
const SIDES = {
  top: {
    bottom: '100%',
    left: '50%',
    transform: 'translateX(-50%) translateY(-8px)'
  },
  bottom: {
    top: '100%',
    left: '50%',
    transform: 'translateX(-50%) translateY(8px)'
  },
  left: {
    right: '100%',
    top: '50%',
    transform: 'translateY(-50%) translateX(-8px)'
  },
  right: {
    left: '100%',
    top: '50%',
    transform: 'translateY(-50%) translateX(8px)'
  }
};

/** Hover/focus tooltip. Wraps a single trigger; positions on one of four sides. */
function Tooltip({
  label,
  side = 'top',
  children,
  style
}) {
  const [show, setShow] = React.useState(false);
  return /*#__PURE__*/React.createElement("span", {
    style: {
      position: 'relative',
      display: 'inline-flex'
    },
    onMouseEnter: () => setShow(true),
    onMouseLeave: () => setShow(false),
    onFocus: () => setShow(true),
    onBlur: () => setShow(false)
  }, children, show && /*#__PURE__*/React.createElement("span", {
    role: "tooltip",
    style: {
      position: 'absolute',
      zIndex: 'var(--z-toast)',
      whiteSpace: 'nowrap',
      background: 'var(--surface2)',
      color: 'var(--ink)',
      border: '1px solid var(--border)',
      borderRadius: 8,
      padding: '6px 10px',
      fontSize: 12.5,
      fontFamily: 'var(--font-body)',
      boxShadow: 'var(--shadow-sm)',
      pointerEvents: 'none',
      ...SIDES[side],
      ...style
    }
  }, label));
}
Object.assign(__ds_scope, { Tooltip });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/feedback/Tooltip.jsx", error: String((e && e.message) || e) }); }

// components/forms/Checkbox.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/** Checkbox with iris fill + check on. Pass `label` for the inline label. */
function Checkbox({
  checked = false,
  label,
  disabled = false,
  onChange,
  id,
  style,
  ...rest
}) {
  const auto = React.useId();
  const cid = id || auto;
  return /*#__PURE__*/React.createElement("label", {
    htmlFor: cid,
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: 10,
      cursor: disabled ? 'not-allowed' : 'pointer',
      opacity: disabled ? 0.5 : 1,
      ...style
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      position: 'relative',
      width: 20,
      height: 20,
      flex: 'none'
    }
  }, /*#__PURE__*/React.createElement("input", _extends({
    id: cid,
    type: "checkbox",
    checked: checked,
    disabled: disabled,
    onChange: onChange,
    style: {
      position: 'absolute',
      opacity: 0,
      width: '100%',
      height: '100%',
      margin: 0,
      cursor: 'inherit'
    }
  }, rest)), /*#__PURE__*/React.createElement("span", {
    style: {
      position: 'absolute',
      inset: 0,
      borderRadius: 6,
      border: `1px solid ${checked ? 'var(--primary)' : 'var(--input-border)'}`,
      background: checked ? 'var(--primary)' : 'var(--surface)',
      display: 'grid',
      placeItems: 'center',
      transition: 'background var(--dur) ease, border-color var(--dur) ease'
    }
  }, checked && /*#__PURE__*/React.createElement("svg", {
    width: "12",
    height: "12",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "var(--on-primary)",
    strokeWidth: "3.4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 6 9 17l-5-5"
  })))), label && /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 14.5,
      color: 'var(--ink)'
    }
  }, label));
}
Object.assign(__ds_scope, { Checkbox });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/forms/Checkbox.jsx", error: String((e && e.message) || e) }); }

// components/forms/Input.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Text input with optional label, hint, error, and leading/trailing adornments.
 * Iris focus ring; soft-coral border + mono message on error.
 */
function Input({
  label,
  hint,
  error,
  type = 'text',
  leading,
  trailing,
  id,
  style,
  ...rest
}) {
  const [focus, setFocus] = React.useState(false);
  const auto = React.useId();
  const inputId = id || auto;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 7
    }
  }, label && /*#__PURE__*/React.createElement("label", {
    htmlFor: inputId,
    style: {
      fontFamily: 'var(--font-heading)',
      fontWeight: 500,
      fontSize: 13.5,
      color: 'var(--ink)'
    }
  }, label), /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center'
    }
  }, leading && /*#__PURE__*/React.createElement("span", {
    style: {
      position: 'absolute',
      left: 14,
      display: 'flex',
      color: 'var(--muted)',
      pointerEvents: 'none'
    }
  }, leading), /*#__PURE__*/React.createElement("input", _extends({
    id: inputId,
    type: type,
    onFocus: () => setFocus(true),
    onBlur: () => setFocus(false),
    style: {
      width: '100%',
      padding: '12px 14px',
      paddingLeft: leading ? 40 : 14,
      paddingRight: trailing ? 40 : 14,
      borderRadius: 'var(--radius-md)',
      border: `1px solid ${error ? 'var(--danger-line)' : focus ? 'var(--primary)' : 'var(--input-border)'}`,
      background: 'var(--surface)',
      color: 'var(--ink)',
      fontSize: 15,
      fontFamily: 'var(--font-body)',
      outline: 'none',
      boxShadow: focus && !error ? '0 0 0 3px var(--primary-soft)' : undefined,
      transition: 'border-color var(--dur) ease, box-shadow var(--dur) ease',
      ...style
    }
  }, rest)), trailing && /*#__PURE__*/React.createElement("span", {
    style: {
      position: 'absolute',
      right: 14,
      display: 'flex',
      color: 'var(--muted)'
    }
  }, trailing)), (hint || error) && /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 12.5,
      lineHeight: 1.5,
      color: error ? 'var(--danger)' : 'var(--muted)',
      fontFamily: error ? 'var(--font-mono)' : 'var(--font-body)'
    }
  }, error || hint));
}
Object.assign(__ds_scope, { Input });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/forms/Input.jsx", error: String((e && e.message) || e) }); }

// components/forms/Radio.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/** Radio button with iris dot on. Group several by sharing `name`. */
function Radio({
  checked = false,
  label,
  name,
  value,
  disabled = false,
  onChange,
  id,
  style,
  ...rest
}) {
  const auto = React.useId();
  const rid = id || auto;
  return /*#__PURE__*/React.createElement("label", {
    htmlFor: rid,
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: 10,
      cursor: disabled ? 'not-allowed' : 'pointer',
      opacity: disabled ? 0.5 : 1,
      ...style
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      position: 'relative',
      width: 20,
      height: 20,
      flex: 'none'
    }
  }, /*#__PURE__*/React.createElement("input", _extends({
    id: rid,
    type: "radio",
    name: name,
    value: value,
    checked: checked,
    disabled: disabled,
    onChange: onChange,
    style: {
      position: 'absolute',
      opacity: 0,
      width: '100%',
      height: '100%',
      margin: 0,
      cursor: 'inherit'
    }
  }, rest)), /*#__PURE__*/React.createElement("span", {
    style: {
      position: 'absolute',
      inset: 0,
      borderRadius: '50%',
      border: `1px solid ${checked ? 'var(--primary)' : 'var(--input-border)'}`,
      background: 'var(--surface)',
      display: 'grid',
      placeItems: 'center',
      transition: 'border-color var(--dur) ease'
    }
  }, checked && /*#__PURE__*/React.createElement("span", {
    style: {
      width: 10,
      height: 10,
      borderRadius: '50%',
      background: 'var(--primary)'
    }
  }))), label && /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 14.5,
      color: 'var(--ink)'
    }
  }, label));
}
Object.assign(__ds_scope, { Radio });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/forms/Radio.jsx", error: String((e && e.message) || e) }); }

// components/forms/Select.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/** Native select, brand-styled with a mono-clean chevron. Pass <option>s as children. */
function Select({
  label,
  hint,
  error,
  id,
  children,
  style,
  ...rest
}) {
  const auto = React.useId();
  const sid = id || auto;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 7
    }
  }, label && /*#__PURE__*/React.createElement("label", {
    htmlFor: sid,
    style: {
      fontFamily: 'var(--font-heading)',
      fontWeight: 500,
      fontSize: 13.5,
      color: 'var(--ink)'
    }
  }, label), /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/React.createElement("select", _extends({
    id: sid,
    style: {
      width: '100%',
      appearance: 'none',
      WebkitAppearance: 'none',
      padding: '12px 38px 12px 14px',
      borderRadius: 'var(--radius-md)',
      border: `1px solid ${error ? 'var(--danger-line)' : 'var(--input-border)'}`,
      background: 'var(--surface)',
      color: 'var(--ink)',
      fontSize: 15,
      fontFamily: 'var(--font-body)',
      cursor: 'pointer',
      outline: 'none',
      ...style
    }
  }, rest), children), /*#__PURE__*/React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "var(--muted)",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      position: 'absolute',
      right: 13,
      top: '50%',
      transform: 'translateY(-50%)',
      pointerEvents: 'none'
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6 9 6 6 6-6"
  }))), (hint || error) && /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 12.5,
      lineHeight: 1.5,
      color: error ? 'var(--danger)' : 'var(--muted)'
    }
  }, error || hint));
}
Object.assign(__ds_scope, { Select });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/forms/Select.jsx", error: String((e && e.message) || e) }); }

// components/forms/Switch.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/** Toggle switch — iris track on, knob slides. Use for instant on/off settings. */
function Switch({
  checked = false,
  label,
  disabled = false,
  onChange,
  id,
  style,
  ...rest
}) {
  const auto = React.useId();
  const sid = id || auto;
  return /*#__PURE__*/React.createElement("label", {
    htmlFor: sid,
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: 10,
      cursor: disabled ? 'not-allowed' : 'pointer',
      opacity: disabled ? 0.5 : 1,
      ...style
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      position: 'relative',
      width: 38,
      height: 22,
      flex: 'none'
    }
  }, /*#__PURE__*/React.createElement("input", _extends({
    id: sid,
    type: "checkbox",
    role: "switch",
    checked: checked,
    disabled: disabled,
    onChange: onChange,
    style: {
      position: 'absolute',
      opacity: 0,
      width: '100%',
      height: '100%',
      margin: 0,
      cursor: 'inherit'
    }
  }, rest)), /*#__PURE__*/React.createElement("span", {
    style: {
      position: 'absolute',
      inset: 0,
      borderRadius: 999,
      background: checked ? 'var(--primary)' : 'var(--surface2)',
      border: `1px solid ${checked ? 'var(--primary-line)' : 'var(--border)'}`,
      transition: 'background var(--dur) ease, border-color var(--dur) ease'
    }
  }), /*#__PURE__*/React.createElement("span", {
    style: {
      position: 'absolute',
      top: 3,
      left: checked ? 19 : 3,
      width: 16,
      height: 16,
      borderRadius: '50%',
      background: checked ? 'var(--on-primary)' : 'var(--muted)',
      transition: 'left var(--dur) var(--ease), background var(--dur) ease'
    }
  })), label && /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 14.5,
      color: 'var(--ink)'
    }
  }, label));
}
Object.assign(__ds_scope, { Switch });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/forms/Switch.jsx", error: String((e && e.message) || e) }); }

// components/forms/Textarea.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/** Multi-line text input. Same label/hint/error treatment as Input. */
function Textarea({
  label,
  hint,
  error,
  rows = 4,
  id,
  style,
  ...rest
}) {
  const [focus, setFocus] = React.useState(false);
  const auto = React.useId();
  const tid = id || auto;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 7
    }
  }, label && /*#__PURE__*/React.createElement("label", {
    htmlFor: tid,
    style: {
      fontFamily: 'var(--font-heading)',
      fontWeight: 500,
      fontSize: 13.5,
      color: 'var(--ink)'
    }
  }, label), /*#__PURE__*/React.createElement("textarea", _extends({
    id: tid,
    rows: rows,
    onFocus: () => setFocus(true),
    onBlur: () => setFocus(false),
    style: {
      width: '100%',
      padding: '12px 14px',
      borderRadius: 'var(--radius-md)',
      border: `1px solid ${error ? 'var(--danger-line)' : focus ? 'var(--primary)' : 'var(--input-border)'}`,
      background: 'var(--surface)',
      color: 'var(--ink)',
      fontSize: 15,
      fontFamily: 'var(--font-body)',
      lineHeight: 1.55,
      outline: 'none',
      resize: 'vertical',
      boxShadow: focus && !error ? '0 0 0 3px var(--primary-soft)' : undefined,
      transition: 'border-color var(--dur) ease, box-shadow var(--dur) ease',
      ...style
    }
  }, rest)), (hint || error) && /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 12.5,
      lineHeight: 1.5,
      color: error ? 'var(--danger)' : 'var(--muted)',
      fontFamily: error ? 'var(--font-mono)' : 'var(--font-body)'
    }
  }, error || hint));
}
Object.assign(__ds_scope, { Textarea });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/forms/Textarea.jsx", error: String((e && e.message) || e) }); }

// components/navigation/Avatar.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const TONES = {
  iris: {
    bg: 'var(--primary-soft)',
    color: 'var(--primary)',
    line: 'var(--primary-line)'
  },
  cyan: {
    bg: 'var(--accent-soft)',
    color: 'var(--accent-ink)',
    line: 'var(--accent-line)'
  },
  neutral: {
    bg: 'var(--surface2)',
    color: 'var(--muted)',
    line: 'var(--border)'
  }
};
const STATUS = {
  online: 'var(--accent)',
  busy: 'var(--warn)',
  offline: 'var(--muted)'
};

/**
 * Avatar — initials or image, with an optional status dot. Used for crew agents
 * and people. `status` online pulses (cyan), busy is amber, offline is muted.
 */
function Avatar({
  name = '',
  src,
  size = 36,
  tone = 'iris',
  status,
  style,
  ...rest
}) {
  const initials = name.split(' ').filter(Boolean).map(w => w[0]).slice(0, 2).join('').toUpperCase();
  const t = TONES[tone] || TONES.iris;
  const dot = size * 0.3;
  return /*#__PURE__*/React.createElement("span", _extends({
    style: {
      position: 'relative',
      display: 'inline-flex',
      flex: 'none',
      width: size,
      height: size,
      ...style
    }
  }, rest), src ? /*#__PURE__*/React.createElement("img", {
    src: src,
    alt: name,
    style: {
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      objectFit: 'cover',
      border: '1px solid var(--border)'
    }
  }) : /*#__PURE__*/React.createElement("span", {
    style: {
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      display: 'grid',
      placeItems: 'center',
      background: t.bg,
      color: t.color,
      border: `1px solid ${t.line}`,
      fontFamily: 'var(--font-heading)',
      fontWeight: 600,
      fontSize: Math.round(size * 0.4)
    }
  }, initials), status && /*#__PURE__*/React.createElement("span", {
    style: {
      position: 'absolute',
      right: -1,
      bottom: -1,
      width: dot,
      height: dot,
      borderRadius: '50%',
      background: STATUS[status] || STATUS.offline,
      border: '2px solid var(--surface)',
      animation: status === 'online' ? 'ct-pulse 2.2s ease-in-out infinite' : undefined
    }
  }));
}
Object.assign(__ds_scope, { Avatar });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/navigation/Avatar.jsx", error: String((e && e.message) || e) }); }

// components/navigation/SidebarItem.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Sidebar nav item — icon + label, active + hover states, optional count badge.
 * Active is iris-soft with an iris edge and an iris icon. Built for the Mission
 * Control left rail.
 */
function SidebarItem({
  icon,
  label,
  active = false,
  badge,
  onClick,
  style,
  ...rest
}) {
  const [hover, setHover] = React.useState(false);
  return /*#__PURE__*/React.createElement("button", _extends({
    onClick: onClick,
    onMouseEnter: () => setHover(true),
    onMouseLeave: () => setHover(false),
    "aria-current": active ? 'page' : undefined,
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: 11,
      width: '100%',
      padding: '9px 11px',
      borderRadius: 'var(--radius-md)',
      border: `1px solid ${active ? 'var(--primary-line)' : 'transparent'}`,
      background: active ? 'var(--primary-soft)' : hover ? 'var(--surface2)' : 'transparent',
      color: active ? 'var(--ink)' : 'var(--muted)',
      cursor: 'pointer',
      fontFamily: 'var(--font-body)',
      fontWeight: active ? 600 : 500,
      fontSize: 14,
      textAlign: 'left',
      transition: 'background var(--dur) ease, color var(--dur) ease, border-color var(--dur) ease',
      ...style
    }
  }, rest), icon && /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'flex',
      flex: 'none',
      color: active ? 'var(--primary)' : 'currentColor'
    }
  }, icon), /*#__PURE__*/React.createElement("span", {
    style: {
      flex: 1
    }
  }, label), badge != null && /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-mono)',
      fontSize: 10.5,
      fontWeight: 600,
      minWidth: 18,
      textAlign: 'center',
      padding: '1px 6px',
      borderRadius: 999,
      background: active ? 'var(--primary)' : 'var(--surface2)',
      color: active ? 'var(--on-primary)' : 'var(--muted)',
      border: active ? 'none' : '1px solid var(--border)'
    }
  }, badge));
}
Object.assign(__ds_scope, { SidebarItem });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/navigation/SidebarItem.jsx", error: String((e && e.message) || e) }); }

// components/navigation/Tabs.jsx
try { (() => {
/**
 * Underline tabs. Controlled: pass `tabs` ({ id, label, badge? }), the active
 * `value`, and `onChange`. Active tab gets an iris underline + bolder weight.
 */
function Tabs({
  tabs = [],
  value,
  onChange,
  style
}) {
  return /*#__PURE__*/React.createElement("div", {
    role: "tablist",
    style: {
      display: 'flex',
      gap: 4,
      borderBottom: '1px solid var(--border)',
      ...style
    }
  }, tabs.map(t => {
    const active = t.id === value;
    return /*#__PURE__*/React.createElement("button", {
      key: t.id,
      role: "tab",
      "aria-selected": active,
      onClick: () => onChange && onChange(t.id),
      style: {
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'center',
        gap: 7,
        padding: '10px 14px',
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        fontFamily: 'var(--font-heading)',
        fontWeight: active ? 600 : 500,
        fontSize: 14,
        color: active ? 'var(--ink)' : 'var(--muted)',
        borderBottom: `2px solid ${active ? 'var(--primary)' : 'transparent'}`,
        marginBottom: -1,
        transition: 'color var(--dur) ease, border-color var(--dur) ease'
      }
    }, t.label, t.badge != null && /*#__PURE__*/React.createElement("span", {
      style: {
        fontFamily: 'var(--font-mono)',
        fontSize: 10.5,
        fontWeight: 600,
        padding: '1px 6px',
        borderRadius: 999,
        background: active ? 'var(--primary-soft)' : 'var(--surface2)',
        color: active ? 'var(--primary)' : 'var(--muted)',
        border: `1px solid ${active ? 'var(--primary-line)' : 'var(--border)'}`
      }
    }, t.badge));
  }));
}
Object.assign(__ds_scope, { Tabs });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/navigation/Tabs.jsx", error: String((e && e.message) || e) }); }

// ui_kits/mission-control/data.js
try { (() => {
/* ============================================================
   CarrTech.AI Mission Control — fake-but-coherent data.
   Grounded in the real studio model: a small AI crew builds under
   human direction; a person signs off every release. Numbers are
   realistic for a solo founder's studio. All invented for the mock.
   ============================================================ */
window.MC_DATA = {
  user: {
    name: 'Cassidy Carr',
    email: 'cassidy@carrtech.ai',
    role: 'Founder · Director'
  },
  /* ---- COMMAND · system health (green | amber | red) ---- */
  health: [{
    id: 'site',
    name: 'Site',
    sub: 'carrtech.ai',
    status: 'green',
    metric: '200 OK',
    detail: '118ms p95',
    icon: 'globe'
  }, {
    id: 'workers',
    name: 'Workers',
    sub: 'Cloudflare',
    status: 'green',
    metric: 'healthy',
    detail: '3 regions · 0 cold',
    icon: 'server'
  }, {
    id: 'ci',
    name: 'GitHub CI',
    sub: 'Actions',
    status: 'amber',
    metric: '1 queued',
    detail: '2 running · 1 waiting',
    icon: 'git'
  }, {
    id: 'sentry',
    name: 'Sentry',
    sub: 'errors',
    status: 'red',
    metric: '1 new',
    detail: 'spike · subscribe.ts',
    icon: 'bug'
  }, {
    id: 'anthropic',
    name: 'Anthropic',
    sub: 'API',
    status: 'green',
    metric: 'operational',
    detail: '430ms median',
    icon: 'spark'
  }],
  /* ---- COMMAND + MONEY · AI budget (amber ≥70%, red ≥90%) ---- */
  budget: {
    spent: 666,
    cap: 900,
    tokensSpent: 44.4,
    tokensCap: 60,
    tokenUnit: 'M tok',
    daysLeft: 8,
    perDay: 83,
    pct: 74,
    // 666/900
    cycle: 'June · resets in 8 days'
  },
  /* ---- live cross-system activity feed ---- */
  activity: [{
    sys: 'agent',
    actor: 'Forge',
    text: 'opened PR #128 · logbook view',
    tone: 'iris',
    time: '12s'
  }, {
    sys: 'ci',
    actor: '',
    text: 'check suite started on PR #128',
    tone: 'warn',
    time: '40s'
  }, {
    sys: 'site',
    actor: '',
    text: 'traffic spike · 48 visitors online',
    tone: 'cyan',
    time: '1m'
  }, {
    sys: 'agent',
    actor: 'Iris',
    text: 'pushed 3 screens to trailquest-web',
    tone: 'cyan',
    time: '2m'
  }, {
    sys: 'sentry',
    actor: '',
    text: 'new issue · TypeError in subscribe.ts',
    tone: 'danger',
    time: '6m'
  }, {
    sys: 'deploy',
    actor: 'Vela',
    text: 'shipped carrtech-web to production',
    tone: 'iris',
    time: '9m'
  }, {
    sys: 'agent',
    actor: 'Scout',
    text: 'filed a brief on offline map SDKs',
    tone: 'cyan',
    time: '17m'
  }, {
    sys: 'human',
    actor: 'Cassidy',
    text: 'signed off trailquest-api v0.8',
    tone: 'iris',
    time: '1h'
  }, {
    sys: 'anthropic',
    actor: '',
    text: 'budget crossed 70% · amber',
    tone: 'warn',
    time: '1h'
  }],
  /* ---- CREW · the AI crew. lead = iris, crew = cyan ---- */
  crew: [{
    id: 'atlas',
    name: 'Atlas',
    glyph: '🧭',
    role: 'Orchestrator',
    lead: true,
    status: 'running',
    task: 'Routing the trailquest-web build',
    tokens: '8.2M',
    elapsed: '2h 14m',
    cost: 124
  }, {
    id: 'forge',
    name: 'Forge',
    glyph: '🔨',
    role: 'Build lead',
    lead: true,
    status: 'running',
    task: 'PR #128 · logbook view',
    tokens: '11.6M',
    elapsed: '46m',
    cost: 188
  }, {
    id: 'iris',
    name: 'Iris',
    glyph: '🎨',
    role: 'Design',
    lead: false,
    status: 'running',
    task: 'Badge shelf + quest-complete screen',
    tokens: '4.1M',
    elapsed: '1h 02m',
    cost: 71
  }, {
    id: 'probe',
    name: 'Probe',
    glyph: '🔬',
    role: 'QA',
    lead: false,
    status: 'blocked',
    task: 'Waiting on preview deploy',
    tokens: '2.3M',
    elapsed: '18m',
    cost: 32
  }, {
    id: 'scout',
    name: 'Scout',
    glyph: '🔭',
    role: 'Research',
    lead: false,
    status: 'idle',
    task: 'Offline map brief — delivered',
    tokens: '1.4M',
    elapsed: '—',
    cost: 19
  }, {
    id: 'gate',
    name: 'Gate',
    glyph: '🛡️',
    role: 'Security',
    lead: false,
    status: 'errored',
    task: 'Secret scan failed on carrtech-web',
    tokens: '0.9M',
    elapsed: '4m',
    cost: 12
  }],
  /* full badge set — the crew roster, including idle members + the open slot */
  roster: [{
    name: 'Atlas',
    glyph: '🧭',
    lead: true
  }, {
    name: 'Forge',
    glyph: '🔨',
    lead: true
  }, {
    name: 'Vela',
    glyph: '⛵',
    lead: false
  }, {
    name: 'Tide',
    glyph: '🌊',
    lead: false
  }, {
    name: 'Scout',
    glyph: '🔭',
    lead: false
  }, {
    name: 'Quill',
    glyph: '🪶',
    lead: false
  }, {
    name: 'Halo',
    glyph: '🛟',
    lead: false
  }, {
    name: 'Gate',
    glyph: '🛡️',
    lead: false
  }, {
    name: 'Pixel',
    glyph: '📱',
    lead: false
  }, {
    name: 'Iris',
    glyph: '🎨',
    lead: false
  }, {
    name: 'Probe',
    glyph: '🔬',
    lead: false
  }, {
    name: 'Keel',
    glyph: '⚓',
    lead: false
  }, {
    name: 'Beacon',
    glyph: '🔦',
    lead: false
  }],
  /* CREW · live trace (most recent agent steps) */
  trace: [{
    agent: 'Forge',
    step: 'wrote src/pages/logbook.astro',
    tone: 'iris',
    dur: '2.1s',
    time: '12s'
  }, {
    agent: 'Forge',
    step: 'ran build · 0 errors',
    tone: 'iris',
    dur: '8.4s',
    time: '34s'
  }, {
    agent: 'Iris',
    step: 'exported BadgeShelf component',
    tone: 'cyan',
    dur: '1.2s',
    time: '1m'
  }, {
    agent: 'Atlas',
    step: 'assigned QA pass to Probe',
    tone: 'iris',
    dur: '0.3s',
    time: '2m'
  }, {
    agent: 'Gate',
    step: 'secret scan → 1 finding',
    tone: 'danger',
    dur: '5.0s',
    time: '4m'
  }],
  /* CREW · mini kanban */
  kanban: {
    Research: [{
      t: 'Offline map SDK',
      who: '🔭'
    }],
    Design: [{
      t: 'Badge shelf',
      who: '🎨'
    }, {
      t: 'Quest-complete',
      who: '🎨'
    }],
    Build: [{
      t: 'Logbook view · PR #128',
      who: '🔨'
    }, {
      t: 'Subscribe fix',
      who: '🔨'
    }],
    Live: [{
      t: 'trailquest-api v0.8',
      who: '⚓'
    }, {
      t: 'carrtech.ai',
      who: '⛵'
    }]
  },
  /* ---- SITE ---- */
  site: {
    requests: [42, 38, 51, 47, 63, 58, 72, 69, 61, 78, 74, 66, 81, 92, 88, 79, 96, 104, 98, 112, 119, 108, 124, 131],
    requestsTotal: '1.9k',
    requestsDelta: '+18%',
    visitors: 312,
    visitorsDelta: '+24',
    online: 48,
    uptime: '99.98%',
    errorRate: '0.2%',
    subscribers: 1284,
    subsDelta: '+31',
    topPages: [{
      path: '/',
      views: 842,
      pct: 64
    }, {
      path: '/brand',
      views: 268,
      pct: 20
    }, {
      path: '/#contact',
      views: 121,
      pct: 9
    }, {
      path: '/#process',
      views: 53,
      pct: 4
    }]
  },
  /* ---- CODE ---- */
  code: {
    velocity: [3, 5, 2, 8, 6, 11, 7, 9, 4, 12, 8, 14, 10, 11],
    velocityLabel: 'commits / day',
    prs: [{
      id: 128,
      title: 'Logbook view + badge shelf',
      author: 'Forge',
      age: '12m',
      checks: 'running',
      repo: 'trailquest-web'
    }, {
      id: 127,
      title: 'Fix subscribe.ts type error',
      author: 'Forge',
      age: '3h',
      checks: 'failed',
      repo: 'carrtech-web'
    }, {
      id: 126,
      title: 'Quest completion endpoint',
      author: 'Keel',
      age: '6h',
      checks: 'passed',
      repo: 'trailquest-api'
    }, {
      id: 119,
      title: 'Onboarding spike',
      author: 'Iris',
      age: '2d',
      checks: 'queued',
      repo: 'app-02'
    }],
    oldest: '2d',
    ci: {
      passed: 18,
      failed: 2,
      running: 1,
      queued: 1
    },
    deploys: [{
      sha: 'a3f9c1e',
      env: 'production',
      status: 'passed',
      repo: 'carrtech-web',
      time: '9m'
    }, {
      sha: '7b21d04',
      env: 'preview',
      status: 'passed',
      repo: 'trailquest-web',
      time: '41m'
    }, {
      sha: 'c0a8f55',
      env: 'production',
      status: 'failed',
      repo: 'carrtech-web',
      time: '3h'
    }, {
      sha: 'e94120a',
      env: 'production',
      status: 'passed',
      repo: 'trailquest-api',
      time: '6h'
    }, {
      sha: '2f7b9cd',
      env: 'preview',
      status: 'passed',
      repo: 'app-02',
      time: '1d'
    }]
  },
  /* ---- MONEY · AI spend ---- */
  money: {
    spend30: [12, 18, 9, 24, 31, 22, 28, 41, 35, 52, 44, 38, 61, 49, 57, 72, 66, 58, 83, 74, 69, 88, 81, 76, 94, 83, 79, 91, 86, 83],
    byModel: [{
      name: 'Claude Opus',
      pct: 58,
      usd: 386,
      tone: 'iris'
    }, {
      name: 'Claude Sonnet',
      pct: 34,
      usd: 226,
      tone: 'cyan'
    }, {
      name: 'Claude Haiku',
      pct: 8,
      usd: 54,
      tone: 'muted'
    }],
    infra: [{
      name: 'Cloudflare',
      usd: 5,
      note: 'Pages + Workers + D1'
    }, {
      name: 'Resend',
      usd: 0,
      note: 'free tier'
    }, {
      name: 'Sentry',
      usd: 0,
      note: 'free tier'
    }]
  },
  /* ---- CONTROLS · audit log ---- */
  audit: [{
    actor: 'Cassidy',
    action: 'Signed off & shipped',
    target: 'carrtech-web → prod',
    result: 'ok',
    time: '9m'
  }, {
    actor: 'Cassidy',
    action: 'Ran agent',
    target: 'Forge · logbook view',
    result: 'ok',
    time: '46m'
  }, {
    actor: 'Cassidy',
    action: 'Toggled flag',
    target: 'trailquest.badges = on',
    result: 'ok',
    time: '2h'
  }, {
    actor: 'Cassidy',
    action: 'Silenced alert',
    target: 'Sentry · subscribe.ts',
    result: 'ok',
    time: '3h'
  }, {
    actor: 'Cassidy',
    action: 'Health-check',
    target: 'all systems',
    result: 'ok',
    time: '5h'
  }],
  /* ---- TALK-TO-AI · seed chat ---- */
  chat: [{
    from: 'ai',
    text: 'Morning, Cassidy. The crew is on trailquest-web — Forge has PR #128 open and checks are running. Gate flagged a secret on carrtech-web; I paused that deploy.'
  }, {
    from: 'me',
    text: 'What did Gate find?'
  }, {
    from: 'ai',
    text: 'A test Resend key committed to src/lib/mail.ts. I can open a PR that moves it to a Pages secret and rotates it — want me to send Forge that task?'
  }]
};
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/mission-control/data.js", error: String((e && e.message) || e) }); }

// ui_kits/mission-control/icons.jsx
try { (() => {
/* global React */
// Lucide-style ~2px line icons for the Mission Control kit. Exported to window.
const MCIcon = ({
  children,
  size = 18,
  sw = 2,
  style
}) => /*#__PURE__*/React.createElement("svg", {
  width: size,
  height: size,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: sw,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  style: style
}, children);

// nav
const IconCommand = p => /*#__PURE__*/React.createElement(MCIcon, p, /*#__PURE__*/React.createElement("rect", {
  x: "3",
  y: "3",
  width: "7",
  height: "7",
  rx: "1.5"
}), /*#__PURE__*/React.createElement("rect", {
  x: "14",
  y: "3",
  width: "7",
  height: "7",
  rx: "1.5"
}), /*#__PURE__*/React.createElement("rect", {
  x: "3",
  y: "14",
  width: "7",
  height: "7",
  rx: "1.5"
}), /*#__PURE__*/React.createElement("rect", {
  x: "14",
  y: "14",
  width: "7",
  height: "7",
  rx: "1.5"
}));
const IconCrew = p => /*#__PURE__*/React.createElement(MCIcon, p, /*#__PURE__*/React.createElement("circle", {
  cx: "9",
  cy: "8",
  r: "3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3 20a6 6 0 0 1 12 0M17 11a3 3 0 1 0 0-6M22 20a6 6 0 0 0-3.5-5.5"
}));
const IconGlobe = p => /*#__PURE__*/React.createElement(MCIcon, p, /*#__PURE__*/React.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3 12h18M12 3c2.5 2.7 2.5 15.3 0 18M12 3c-2.5 2.7-2.5 15.3 0 18"
}));
const IconCode = p => /*#__PURE__*/React.createElement(MCIcon, p, /*#__PURE__*/React.createElement("path", {
  d: "m16 18 6-6-6-6M8 6l-6 6 6 6"
}));
const IconMoney = p => /*#__PURE__*/React.createElement(MCIcon, p, /*#__PURE__*/React.createElement("path", {
  d: "M12 2v20M17 6.5C17 4.6 14.8 3.5 12 3.5S7 4.8 7 7s2 3 5 3.5 5 1.3 5 3.5-2.2 3.5-5 3.5-5-1.1-5-3"
}));
const IconSliders = p => /*#__PURE__*/React.createElement(MCIcon, p, /*#__PURE__*/React.createElement("path", {
  d: "M4 21v-7M4 10V3M12 21v-9M12 8V3M20 21v-5M20 12V3M1 14h6M9 8h6M17 16h6"
}));

// systems
const IconServer = p => /*#__PURE__*/React.createElement(MCIcon, p, /*#__PURE__*/React.createElement("rect", {
  x: "3",
  y: "4",
  width: "18",
  height: "7",
  rx: "1.5"
}), /*#__PURE__*/React.createElement("rect", {
  x: "3",
  y: "13",
  width: "18",
  height: "7",
  rx: "1.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7 7.5h.01M7 16.5h.01"
}));
const IconBug = p => /*#__PURE__*/React.createElement(MCIcon, p, /*#__PURE__*/React.createElement("path", {
  d: "M8 7a4 4 0 0 1 8 0M9 7h6v5a3 3 0 0 1-6 0zM5 10h3M16 10h3M5 16h3M16 16h3M12 15v6M3 13l2-1M19 13l-2-1M3 19l2-1M19 19l-2-1"
}));
const IconSpark = p => /*#__PURE__*/React.createElement(MCIcon, p, /*#__PURE__*/React.createElement("path", {
  d: "M12 3v4M12 17v4M3 12h4M17 12h4M6.3 6.3l2.4 2.4M15.3 15.3l2.4 2.4M17.7 6.3l-2.4 2.4M8.7 15.3l-2.4 2.4"
}));
const IconGit = p => /*#__PURE__*/React.createElement(MCIcon, p, /*#__PURE__*/React.createElement("circle", {
  cx: "6",
  cy: "6",
  r: "2.5"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "6",
  cy: "18",
  r: "2.5"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "18",
  cy: "9",
  r: "2.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6 8.5v7M18 11.5c0 3-3 3.5-6 3.5"
}));

// actions
const IconPlus = p => /*#__PURE__*/React.createElement(MCIcon, p, /*#__PURE__*/React.createElement("path", {
  d: "M12 5v14M5 12h14"
}));
const IconArrow = p => /*#__PURE__*/React.createElement(MCIcon, p, /*#__PURE__*/React.createElement("path", {
  d: "M5 12h14M13 6l6 6-6 6"
}));
const IconCheck = p => /*#__PURE__*/React.createElement(MCIcon, p, /*#__PURE__*/React.createElement("path", {
  d: "M20 6 9 17l-5-5"
}));
const IconX = p => /*#__PURE__*/React.createElement(MCIcon, p, /*#__PURE__*/React.createElement("path", {
  d: "M18 6 6 18M6 6l12 12"
}));
const IconRocket = p => /*#__PURE__*/React.createElement(MCIcon, p, /*#__PURE__*/React.createElement("path", {
  d: "M5 13c-1.5 1.3-2 5-2 5s3.7-.5 5-2M9 11a8 8 0 0 1 7-7c3 0 4 1 4 4a8 8 0 0 1-7 7l-2 .5L8.5 13zM14 9.5h.01"
}));
const IconFlag = p => /*#__PURE__*/React.createElement(MCIcon, p, /*#__PURE__*/React.createElement("path", {
  d: "M4 21V4M4 4h13l-2 4 2 4H4"
}));
const IconBroadcast = p => /*#__PURE__*/React.createElement(MCIcon, p, /*#__PURE__*/React.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "2.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.5 5.5a9 9 0 0 0 0 13M18.5 5.5a9 9 0 0 1 0 13M8 8a5 5 0 0 0 0 8M16 8a5 5 0 0 1 0 8"
}));
const IconShield = p => /*#__PURE__*/React.createElement(MCIcon, p, /*#__PURE__*/React.createElement("path", {
  d: "M12 3l8 3v5c0 5-3.5 8.5-8 10-4.5-1.5-8-5-8-10V6z"
}));
const IconHeartbeat = p => /*#__PURE__*/React.createElement(MCIcon, p, /*#__PURE__*/React.createElement("path", {
  d: "M3 12h4l2-6 4 12 2-6h6"
}));
const IconBellOff = p => /*#__PURE__*/React.createElement(MCIcon, p, /*#__PURE__*/React.createElement("path", {
  d: "M8.7 4.3A6 6 0 0 1 18 8c0 3 1 5 1 5M6 8c0 5-3 7-3 7h13M13.7 21a2 2 0 0 1-3.4 0M3 3l18 18"
}));
const IconSend = p => /*#__PURE__*/React.createElement(MCIcon, p, /*#__PURE__*/React.createElement("path", {
  d: "M22 2 11 13M22 2l-7 20-4-9-9-4z"
}));
const IconChat = p => /*#__PURE__*/React.createElement(MCIcon, p, /*#__PURE__*/React.createElement("path", {
  d: "M21 12a8 8 0 0 1-11.5 7.2L3 21l1.8-6.5A8 8 0 1 1 21 12Z"
}));
const IconSearch = p => /*#__PURE__*/React.createElement(MCIcon, p, /*#__PURE__*/React.createElement("circle", {
  cx: "11",
  cy: "11",
  r: "7"
}), /*#__PURE__*/React.createElement("path", {
  d: "m21 21-4.3-4.3"
}));
const IconBell = p => /*#__PURE__*/React.createElement(MCIcon, p, /*#__PURE__*/React.createElement("path", {
  d: "M18 8a6 6 0 0 0-12 0c0 7-3 8-3 8h18s-3-1-3-8M13.7 21a2 2 0 0 1-3.4 0"
}));
const IconSun = p => /*#__PURE__*/React.createElement(MCIcon, p, /*#__PURE__*/React.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 2v2M12 20v2M4 12H2M22 12h-2M5.6 5.6 4.2 4.2M19.8 19.8l-1.4-1.4M18.4 5.6l1.4-1.4M4.2 19.8l1.4-1.4"
}));
const IconMoon = p => /*#__PURE__*/React.createElement(MCIcon, p, /*#__PURE__*/React.createElement("path", {
  d: "M21 12.8A9 9 0 1 1 11.2 3 7 7 0 0 0 21 12.8Z"
}));
const IconClock = p => /*#__PURE__*/React.createElement(MCIcon, p, /*#__PURE__*/React.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 7v5l3 2"
}));
const IconFile = p => /*#__PURE__*/React.createElement(MCIcon, p, /*#__PURE__*/React.createElement("path", {
  d: "M14 3v5h5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19 8v11a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h8z"
}));
const IconEye = p => /*#__PURE__*/React.createElement(MCIcon, p, /*#__PURE__*/React.createElement("path", {
  d: "M2 12s4-7 10-7 10 7 10 7-4 7-10 7-10-7-10-7Z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "3"
}));
const IconUsers = p => /*#__PURE__*/React.createElement(MCIcon, p, /*#__PURE__*/React.createElement("circle", {
  cx: "9",
  cy: "8",
  r: "3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3 20a6 6 0 0 1 12 0M17 11a3 3 0 1 0 0-6M22 20a6 6 0 0 0-3.5-5.5"
}));
const IconLogout = p => /*#__PURE__*/React.createElement(MCIcon, p, /*#__PURE__*/React.createElement("path", {
  d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9"
}));
const IconChevron = p => /*#__PURE__*/React.createElement(MCIcon, p, /*#__PURE__*/React.createElement("path", {
  d: "m6 9 6 6 6-6"
}));
const IconExternal = p => /*#__PURE__*/React.createElement(MCIcon, p, /*#__PURE__*/React.createElement("path", {
  d: "M15 3h6v6M21 3l-9 9M10 5H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-5"
}));
const IconGoogle = ({
  size = 18
}) => /*#__PURE__*/React.createElement("svg", {
  width: size,
  height: size,
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#4285F4",
  d: "M22.5 12.27c0-.79-.07-1.54-.2-2.27H12v4.51h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.21-4.74 3.21-8.33z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#34A853",
  d: "M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.99.66-2.26 1.06-3.71 1.06-2.86 0-5.28-1.93-6.14-4.53H2.18v2.84A11 11 0 0 0 12 23z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FBBC05",
  d: "M5.86 14.1a6.6 6.6 0 0 1 0-4.2V7.06H2.18a11 11 0 0 0 0 9.88l3.68-2.84z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EA4335",
  d: "M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1A11 11 0 0 0 2.18 7.06l3.68 2.84C6.72 7.3 9.14 5.38 12 5.38z"
}));
Object.assign(window, {
  MCIcon,
  IconCommand,
  IconCrew,
  IconGlobe,
  IconCode,
  IconMoney,
  IconSliders,
  IconServer,
  IconBug,
  IconSpark,
  IconGit,
  IconPlus,
  IconArrow,
  IconCheck,
  IconX,
  IconRocket,
  IconFlag,
  IconBroadcast,
  IconShield,
  IconHeartbeat,
  IconBellOff,
  IconSend,
  IconChat,
  IconSearch,
  IconBell,
  IconSun,
  IconMoon,
  IconClock,
  IconFile,
  IconEye,
  IconUsers,
  IconLogout,
  IconChevron,
  IconExternal,
  IconGoogle
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/mission-control/icons.jsx", error: String((e && e.message) || e) }); }

// ui_kits/mission-control/mc-widgets.jsx
try { (() => {
/* global React */
// Mission Control shared widgets. Exported to window.
// Sparkline · BudgetGauge · HealthTile · AlertBanner · WidgetFrame (+ states)

const mcLabel = {
  fontFamily: 'var(--font-mono)',
  fontSize: 11,
  letterSpacing: '0.1em',
  textTransform: 'uppercase',
  color: 'var(--muted)'
};
const toneColor = t => ({
  iris: 'var(--primary)',
  cyan: 'var(--accent)',
  warn: 'var(--warn)',
  danger: 'var(--danger)',
  muted: 'var(--muted)'
})[t] || 'var(--primary)';
const toneGlow = t => ({
  iris: 'var(--glow-iris)',
  cyan: 'var(--glow-cyan)'
})[t] || 'var(--glow-iris)';

/* ---------- Sparkline ---------- */
function Sparkline({
  data = [],
  height = 40,
  tone = 'cyan',
  fill = true,
  strokeWidth = 2,
  style
}) {
  const w = 100;
  const min = Math.min(...data),
    max = Math.max(...data);
  const span = max - min || 1;
  const pts = data.map((v, i) => [i / (data.length - 1) * w, height - 4 - (v - min) / span * (height - 8)]);
  const line = pts.map((p, i) => `${i ? 'L' : 'M'}${p[0].toFixed(2)} ${p[1].toFixed(2)}`).join(' ');
  const area = `${line} L${w} ${height} L0 ${height} Z`;
  const c = toneColor(tone);
  const gid = React.useMemo(() => 'sg' + Math.random().toString(36).slice(2, 8), []);
  const last = pts[pts.length - 1];
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: `0 0 ${w} ${height}`,
    width: "100%",
    height: height,
    preserveAspectRatio: "none",
    style: {
      display: 'block',
      overflow: 'visible',
      ...style
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: gid,
    x1: "0",
    y1: "0",
    x2: "0",
    y2: "1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: c,
    stopOpacity: "0.28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: c,
    stopOpacity: "0"
  }))), fill && /*#__PURE__*/React.createElement("path", {
    d: area,
    fill: `url(#${gid})`
  }), /*#__PURE__*/React.createElement("path", {
    d: line,
    fill: "none",
    stroke: c,
    strokeWidth: strokeWidth,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    vectorEffect: "non-scaling-stroke"
  }), last && /*#__PURE__*/React.createElement("circle", {
    cx: last[0],
    cy: last[1],
    r: "2.4",
    fill: c,
    vectorEffect: "non-scaling-stroke"
  }));
}

/* ---------- BudgetGauge (semicircle arc, amber ≥70 / red ≥90) ---------- */
function BudgetGauge({
  pct = 0,
  spent,
  cap,
  unit = '$',
  tokensSpent,
  tokensCap,
  tokenUnit,
  daysLeft,
  cycle
}) {
  const r = 92,
    cx = 110,
    cy = 112;
  const len = Math.PI * r;
  const clamped = Math.max(0, Math.min(100, pct));
  const tone = clamped >= 90 ? 'danger' : clamped >= 70 ? 'warn' : 'cyan';
  const c = toneColor(tone);
  const tick = f => {
    const th = Math.PI - f / 100 * Math.PI;
    const x1 = cx + (r - 9) * Math.cos(th),
      y1 = cy - (r - 9) * Math.sin(th);
    const x2 = cx + (r + 9) * Math.cos(th),
      y2 = cy - (r + 9) * Math.sin(th);
    return {
      x1,
      y1,
      x2,
      y2
    };
  };
  const t70 = tick(70),
    t90 = tick(90);
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: 24,
      flexWrap: 'wrap'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative',
      width: 220,
      flex: 'none'
    }
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 220 132",
    width: "100%",
    style: {
      display: 'block'
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: `M${cx - r} ${cy} A ${r} ${r} 0 0 1 ${cx + r} ${cy}`,
    fill: "none",
    stroke: "var(--surface2)",
    strokeWidth: "14",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: `M${cx - r} ${cy} A ${r} ${r} 0 0 1 ${cx + r} ${cy}`,
    fill: "none",
    stroke: c,
    strokeWidth: "14",
    strokeLinecap: "round",
    strokeDasharray: `${clamped / 100 * len} ${len}`,
    style: {
      filter: `drop-shadow(0 0 8px ${toneGlow(tone === 'cyan' ? 'cyan' : 'iris')})`,
      transition: 'stroke-dasharray var(--dur-slow) var(--ease)'
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: t70.x1,
    y1: t70.y1,
    x2: t70.x2,
    y2: t70.y2,
    stroke: "var(--warn)",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: t90.x1,
    y1: t90.y1,
    x2: t90.x2,
    y2: t90.y2,
    stroke: "var(--danger)",
    strokeWidth: "2"
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      inset: 0,
      top: 28,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: 'var(--font-heading)',
      fontWeight: 600,
      fontSize: 38,
      lineHeight: 1,
      letterSpacing: '-0.02em',
      color: c
    }
  }, clamped, "%"), /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: 'var(--font-mono)',
      fontSize: 11.5,
      color: 'var(--muted)',
      marginTop: 4
    }
  }, unit, spent, " / ", unit, cap))), /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1,
      minWidth: 150,
      display: 'flex',
      flexDirection: 'column',
      gap: 12
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    style: mcLabel
  }, "tokens"), /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: 'var(--font-heading)',
      fontWeight: 600,
      fontSize: 19,
      color: 'var(--ink)',
      marginTop: 4
    }
  }, tokensSpent, /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'var(--muted)',
      fontWeight: 400,
      fontSize: 14
    }
  }, " / ", tokensCap, " ", tokenUnit))), /*#__PURE__*/React.createElement("div", {
    style: {
      height: 1,
      background: 'var(--border)'
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: 9
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      width: 8,
      height: 8,
      borderRadius: '50%',
      background: c,
      boxShadow: `0 0 8px ${c}`,
      animation: 'ct-pulse 2s ease-in-out infinite'
    }
  }), /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-heading)',
      fontWeight: 600,
      fontSize: 15,
      color: 'var(--ink)'
    }
  }, "Runs out in ", daysLeft, " days")), /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: 'var(--font-mono)',
      fontSize: 11,
      color: 'var(--muted)'
    }
  }, cycle)));
}

/* ---------- HealthTile (color is never the only signal) ---------- */
const HEALTH = {
  green: {
    word: 'OK',
    color: 'var(--accent-ink)',
    bg: 'var(--accent-soft)',
    line: 'var(--accent-line)',
    mark: /*#__PURE__*/React.createElement("path", {
      d: "M20 6 9 17l-5-5"
    })
  },
  amber: {
    word: 'Degraded',
    color: 'var(--warn)',
    bg: 'var(--warn-soft)',
    line: 'var(--warn-line)',
    mark: /*#__PURE__*/React.createElement("path", {
      d: "M12 9v4M12 17h.01M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h16.9a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z"
    })
  },
  red: {
    word: 'Down',
    color: 'var(--danger)',
    bg: 'var(--danger-soft)',
    line: 'var(--danger-line)',
    mark: /*#__PURE__*/React.createElement("path", {
      d: "M18 6 6 18M6 6l12 12"
    })
  }
};
function HealthTile({
  name,
  sub,
  status = 'green',
  metric,
  detail,
  icon,
  onClick
}) {
  const s = HEALTH[status] || HEALTH.green;
  const SysIcon = icon ? window['Icon' + icon.charAt(0).toUpperCase() + icon.slice(1)] : null;
  return /*#__PURE__*/React.createElement("button", {
    onClick: onClick,
    style: {
      textAlign: 'left',
      cursor: onClick ? 'pointer' : 'default',
      background: 'var(--surface)',
      border: `1px solid ${status === 'red' ? 'var(--danger-line)' : 'var(--border)'}`,
      borderRadius: 'var(--radius-md)',
      padding: 15,
      display: 'flex',
      flexDirection: 'column',
      gap: 12,
      minWidth: 0,
      boxShadow: status === 'red' ? '0 0 0 1px var(--danger-line), 0 14px 40px -28px var(--danger)' : undefined
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 8
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'var(--muted)',
      display: 'flex',
      flex: 'none'
    }
  }, SysIcon && /*#__PURE__*/React.createElement(SysIcon, {
    size: 17
  })), /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: 5,
      flex: 'none',
      padding: '3px 8px 3px 6px',
      borderRadius: 999,
      color: s.color,
      background: s.bg,
      border: `1px solid ${s.line}`,
      fontFamily: 'var(--font-mono)',
      fontSize: 10,
      fontWeight: 600,
      letterSpacing: '0.04em',
      textTransform: 'uppercase',
      whiteSpace: 'nowrap'
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: "11",
    height: "11",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2.6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, s.mark), s.word)), /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: 0
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: 'var(--font-heading)',
      fontWeight: 600,
      fontSize: 14,
      color: 'var(--ink)',
      lineHeight: 1.1,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    }
  }, name), /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: 'var(--font-mono)',
      fontSize: 10.5,
      color: 'var(--muted)',
      marginTop: 3,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    }
  }, sub)), /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: 0
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: 'var(--font-heading)',
      fontWeight: 600,
      fontSize: 17,
      color: 'var(--ink)',
      letterSpacing: '-0.01em',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    }
  }, metric), /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: 'var(--font-mono)',
      fontSize: 10.5,
      color: 'var(--muted)',
      marginTop: 3,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    }
  }, detail)));
}

/* ---------- AlertBanner (red-alert ribbon) ---------- */
function AlertBanner({
  tone = 'danger',
  children,
  onDismiss,
  action
}) {
  const c = toneColor(tone);
  return /*#__PURE__*/React.createElement("div", {
    role: "alert",
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: 12,
      padding: '11px 14px',
      borderRadius: 'var(--radius-md)',
      background: tone === 'danger' ? 'var(--danger-soft)' : 'var(--warn-soft)',
      border: `1px solid ${tone === 'danger' ? 'var(--danger-line)' : 'var(--warn-line)'}`
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'flex',
      color: c,
      flex: 'none'
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: "17",
    height: "17",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2.2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 9v4M12 17h.01M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h16.9a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z"
  }))), /*#__PURE__*/React.createElement("span", {
    style: {
      flex: 1,
      fontSize: 13.5,
      color: 'var(--ink)'
    }
  }, children), action, onDismiss && /*#__PURE__*/React.createElement("button", {
    onClick: onDismiss,
    "aria-label": "Dismiss",
    style: {
      background: 'none',
      border: 'none',
      color: 'var(--muted)',
      cursor: 'pointer',
      padding: 2,
      lineHeight: 0
    }
  }, /*#__PURE__*/React.createElement(window.IconX, {
    size: 15
  })));
}

/* ---------- WidgetFrame + states (live / loading / empty / error) ---------- */
function Skeleton({
  rows = 3
}) {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 12,
      padding: '4px 0'
    }
  }, Array.from({
    length: rows
  }).map((_, i) => /*#__PURE__*/React.createElement("div", {
    key: i,
    style: {
      display: 'flex',
      gap: 12,
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: 32,
      height: 32,
      borderRadius: 8,
      background: 'var(--surface2)',
      animation: 'ct-pulse 1.5s ease-in-out infinite',
      flex: 'none'
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      gap: 7
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      height: 9,
      width: `${70 - i * 12}%`,
      borderRadius: 5,
      background: 'var(--surface2)',
      animation: 'ct-pulse 1.5s ease-in-out infinite'
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      height: 9,
      width: `${45 - i * 8}%`,
      borderRadius: 5,
      background: 'var(--surface2)',
      animation: 'ct-pulse 1.5s ease-in-out infinite'
    }
  })))));
}
function CenterState({
  icon,
  label,
  sub,
  tone = 'muted',
  action
}) {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      gap: 8,
      padding: '22px 12px',
      minHeight: 92
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      color: toneColor(tone),
      display: 'flex'
    }
  }, icon), /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-heading)',
      fontWeight: 600,
      fontSize: 14,
      color: tone === 'danger' ? 'var(--danger)' : 'var(--ink)'
    }
  }, label), sub && /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 12.5,
      color: 'var(--muted)',
      maxWidth: 240
    }
  }, sub), action);
}
function WidgetFrame({
  title,
  actions,
  state = 'live',
  emptyLabel = 'Nothing here yet',
  emptySub,
  errorLabel = 'Couldn’t load',
  errorSub = 'The source didn’t respond.',
  onRetry,
  minHeight = 0,
  glow = false,
  pad = 18,
  children,
  style
}) {
  const NS = window.CarrTechAIDesignSystem_ad3660;
  let body;
  if (state === 'loading') body = /*#__PURE__*/React.createElement(Skeleton, null);else if (state === 'empty') body = /*#__PURE__*/React.createElement(CenterState, {
    icon: /*#__PURE__*/React.createElement(window.IconPlus, {
      size: 22
    }),
    label: emptyLabel,
    sub: emptySub
  });else if (state === 'error') body = /*#__PURE__*/React.createElement(CenterState, {
    tone: "danger",
    icon: /*#__PURE__*/React.createElement(window.IconBug, {
      size: 22
    }),
    label: errorLabel,
    sub: errorSub,
    action: onRetry && NS ? /*#__PURE__*/React.createElement(NS.Button, {
      size: "sm",
      variant: "secondary",
      style: {
        marginTop: 4
      },
      onClick: onRetry
    }, "Retry") : null
  });else body = children;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative',
      background: 'var(--surface)',
      border: `1px solid ${glow ? 'var(--accent-line)' : 'var(--border)'}`,
      borderRadius: 'var(--radius-lg)',
      boxShadow: glow ? '0 18px 50px -30px var(--glow-cyan)' : undefined,
      padding: pad,
      ...style
    }
  }, (title || actions) && /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 10,
      marginBottom: 14
    }
  }, title ? /*#__PURE__*/React.createElement("span", {
    style: mcLabel
  }, title) : /*#__PURE__*/React.createElement("span", null), actions), /*#__PURE__*/React.createElement("div", {
    style: {
      minHeight
    }
  }, body));
}
Object.assign(window, {
  Sparkline,
  BudgetGauge,
  HealthTile,
  AlertBanner,
  WidgetFrame,
  Skeleton,
  mcLabel,
  toneColor
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/mission-control/mc-widgets.jsx", error: String((e && e.message) || e) }); }

// ui_kits/mission-control/tweaks-panel.jsx
try { (() => {
// @ds-adherence-ignore -- omelette starter scaffold (raw elements/hex/px by design)

/* BEGIN USAGE */
// tweaks-panel.jsx
// Reusable Tweaks shell + form-control helpers.
// Exports (to window): useTweaks, TweaksPanel, TweakSection, TweakRow, TweakSlider,
//   TweakToggle, TweakRadio, TweakSelect, TweakText, TweakNumber, TweakColor, TweakButton.
//
// Owns the host protocol (listens for __activate_edit_mode / __deactivate_edit_mode,
// posts __edit_mode_available / __edit_mode_set_keys / __edit_mode_dismissed) so
// individual prototypes don't re-roll it. Ships a consistent set of controls so you
// don't hand-draw <input type="range">, segmented radios, steppers, etc.
//
// Usage (in an HTML file that loads React + Babel):
//
//   const TWEAK_DEFAULTS = /*EDITMODE-BEGIN*/{
//     "primaryColor": "#D97757",
//     "palette": ["#D97757", "#29261b", "#f6f4ef"],
//     "fontSize": 16,
//     "density": "regular",
//     "dark": false
//   }/*EDITMODE-END*/;
//
//   function App() {
//     const [t, setTweak] = useTweaks(TWEAK_DEFAULTS);
//     return (
//       <div style={{ fontSize: t.fontSize, color: t.primaryColor }}>
//         Hello
//         <TweaksPanel>
//           <TweakSection label="Typography" />
//           <TweakSlider label="Font size" value={t.fontSize} min={10} max={32} unit="px"
//                        onChange={(v) => setTweak('fontSize', v)} />
//           <TweakRadio  label="Density" value={t.density}
//                        options={['compact', 'regular', 'comfy']}
//                        onChange={(v) => setTweak('density', v)} />
//           <TweakSection label="Theme" />
//           <TweakColor  label="Primary" value={t.primaryColor}
//                        options={['#D97757', '#2A6FDB', '#1F8A5B', '#7A5AE0']}
//                        onChange={(v) => setTweak('primaryColor', v)} />
//           <TweakColor  label="Palette" value={t.palette}
//                        options={[['#D97757', '#29261b', '#f6f4ef'],
//                                  ['#475569', '#0f172a', '#f1f5f9']]}
//                        onChange={(v) => setTweak('palette', v)} />
//           <TweakToggle label="Dark mode" value={t.dark}
//                        onChange={(v) => setTweak('dark', v)} />
//         </TweaksPanel>
//       </div>
//     );
//   }
//
// TweakRadio is the segmented control for 2–3 short options (auto-falls-back to
// TweakSelect past ~16/~10 chars per label); reach for TweakSelect directly when
// options are many or long. For color tweaks always curate 3-4 options rather than
// a free picker; an option can also be a whole 2–5 color palette (the stored value
// is the array). The Tweak* controls are a floor, not a ceiling — build custom
// controls inside the panel if a tweak calls for UI they don't cover.
/* END USAGE */
// ─────────────────────────────────────────────────────────────────────────────

const __TWEAKS_STYLE = `
  .twk-panel{position:fixed;right:16px;bottom:16px;z-index:2147483646;width:280px;
    max-height:calc(100vh - 32px);display:flex;flex-direction:column;
    transform:scale(var(--dc-inv-zoom,1));transform-origin:bottom right;
    background:rgba(250,249,247,.78);color:#29261b;
    -webkit-backdrop-filter:blur(24px) saturate(160%);backdrop-filter:blur(24px) saturate(160%);
    border:.5px solid rgba(255,255,255,.6);border-radius:14px;
    box-shadow:0 1px 0 rgba(255,255,255,.5) inset,0 12px 40px rgba(0,0,0,.18);
    font:11.5px/1.4 ui-sans-serif,system-ui,-apple-system,sans-serif;overflow:hidden}
  .twk-hd{display:flex;align-items:center;justify-content:space-between;
    padding:10px 8px 10px 14px;cursor:move;user-select:none}
  .twk-hd b{font-size:12px;font-weight:600;letter-spacing:.01em}
  .twk-x{appearance:none;border:0;background:transparent;color:rgba(41,38,27,.55);
    width:22px;height:22px;border-radius:6px;cursor:default;font-size:13px;line-height:1}
  .twk-x:hover{background:rgba(0,0,0,.06);color:#29261b}
  .twk-body{padding:2px 14px 14px;display:flex;flex-direction:column;gap:10px;
    overflow-y:auto;overflow-x:hidden;min-height:0;
    scrollbar-width:thin;scrollbar-color:rgba(0,0,0,.15) transparent}
  .twk-body::-webkit-scrollbar{width:8px}
  .twk-body::-webkit-scrollbar-track{background:transparent;margin:2px}
  .twk-body::-webkit-scrollbar-thumb{background:rgba(0,0,0,.15);border-radius:4px;
    border:2px solid transparent;background-clip:content-box}
  .twk-body::-webkit-scrollbar-thumb:hover{background:rgba(0,0,0,.25);
    border:2px solid transparent;background-clip:content-box}
  .twk-row{display:flex;flex-direction:column;gap:5px}
  .twk-row-h{flex-direction:row;align-items:center;justify-content:space-between;gap:10px}
  .twk-lbl{display:flex;justify-content:space-between;align-items:baseline;
    color:rgba(41,38,27,.72)}
  .twk-lbl>span:first-child{font-weight:500}
  .twk-val{color:rgba(41,38,27,.5);font-variant-numeric:tabular-nums}

  .twk-sect{font-size:10px;font-weight:600;letter-spacing:.06em;text-transform:uppercase;
    color:rgba(41,38,27,.45);padding:10px 0 0}
  .twk-sect:first-child{padding-top:0}

  .twk-field{appearance:none;box-sizing:border-box;width:100%;min-width:0;height:26px;padding:0 8px;
    border:.5px solid rgba(0,0,0,.1);border-radius:7px;
    background:rgba(255,255,255,.6);color:inherit;font:inherit;outline:none}
  .twk-field:focus{border-color:rgba(0,0,0,.25);background:rgba(255,255,255,.85)}
  select.twk-field{padding-right:22px;
    background-image:url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'><path fill='rgba(0,0,0,.5)' d='M0 0h10L5 6z'/></svg>");
    background-repeat:no-repeat;background-position:right 8px center}

  .twk-slider{appearance:none;-webkit-appearance:none;width:100%;height:4px;margin:6px 0;
    border-radius:999px;background:rgba(0,0,0,.12);outline:none}
  .twk-slider::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;
    width:14px;height:14px;border-radius:50%;background:#fff;
    border:.5px solid rgba(0,0,0,.12);box-shadow:0 1px 3px rgba(0,0,0,.2);cursor:default}
  .twk-slider::-moz-range-thumb{width:14px;height:14px;border-radius:50%;
    background:#fff;border:.5px solid rgba(0,0,0,.12);box-shadow:0 1px 3px rgba(0,0,0,.2);cursor:default}

  .twk-seg{position:relative;display:flex;padding:2px;border-radius:8px;
    background:rgba(0,0,0,.06);user-select:none}
  .twk-seg-thumb{position:absolute;top:2px;bottom:2px;border-radius:6px;
    background:rgba(255,255,255,.9);box-shadow:0 1px 2px rgba(0,0,0,.12);
    transition:left .15s cubic-bezier(.3,.7,.4,1),width .15s}
  .twk-seg.dragging .twk-seg-thumb{transition:none}
  .twk-seg button{appearance:none;position:relative;z-index:1;flex:1;border:0;
    background:transparent;color:inherit;font:inherit;font-weight:500;min-height:22px;
    border-radius:6px;cursor:default;padding:4px 6px;line-height:1.2;
    overflow-wrap:anywhere}

  .twk-toggle{position:relative;width:32px;height:18px;border:0;border-radius:999px;
    background:rgba(0,0,0,.15);transition:background .15s;cursor:default;padding:0}
  .twk-toggle[data-on="1"]{background:#34c759}
  .twk-toggle i{position:absolute;top:2px;left:2px;width:14px;height:14px;border-radius:50%;
    background:#fff;box-shadow:0 1px 2px rgba(0,0,0,.25);transition:transform .15s}
  .twk-toggle[data-on="1"] i{transform:translateX(14px)}

  .twk-num{display:flex;align-items:center;box-sizing:border-box;min-width:0;height:26px;padding:0 0 0 8px;
    border:.5px solid rgba(0,0,0,.1);border-radius:7px;background:rgba(255,255,255,.6)}
  .twk-num-lbl{font-weight:500;color:rgba(41,38,27,.6);cursor:ew-resize;
    user-select:none;padding-right:8px}
  .twk-num input{flex:1;min-width:0;height:100%;border:0;background:transparent;
    font:inherit;font-variant-numeric:tabular-nums;text-align:right;padding:0 8px 0 0;
    outline:none;color:inherit;-moz-appearance:textfield}
  .twk-num input::-webkit-inner-spin-button,.twk-num input::-webkit-outer-spin-button{
    -webkit-appearance:none;margin:0}
  .twk-num-unit{padding-right:8px;color:rgba(41,38,27,.45)}

  .twk-btn{appearance:none;height:26px;padding:0 12px;border:0;border-radius:7px;
    background:rgba(0,0,0,.78);color:#fff;font:inherit;font-weight:500;cursor:default}
  .twk-btn:hover{background:rgba(0,0,0,.88)}
  .twk-btn.secondary{background:rgba(0,0,0,.06);color:inherit}
  .twk-btn.secondary:hover{background:rgba(0,0,0,.1)}

  .twk-swatch{appearance:none;-webkit-appearance:none;width:56px;height:22px;
    border:.5px solid rgba(0,0,0,.1);border-radius:6px;padding:0;cursor:default;
    background:transparent;flex-shrink:0}
  .twk-swatch::-webkit-color-swatch-wrapper{padding:0}
  .twk-swatch::-webkit-color-swatch{border:0;border-radius:5.5px}
  .twk-swatch::-moz-color-swatch{border:0;border-radius:5.5px}

  .twk-chips{display:flex;gap:6px}
  .twk-chip{position:relative;appearance:none;flex:1;min-width:0;height:46px;
    padding:0;border:0;border-radius:6px;overflow:hidden;cursor:default;
    box-shadow:0 0 0 .5px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.06);
    transition:transform .12s cubic-bezier(.3,.7,.4,1),box-shadow .12s}
  .twk-chip:hover{transform:translateY(-1px);
    box-shadow:0 0 0 .5px rgba(0,0,0,.18),0 4px 10px rgba(0,0,0,.12)}
  .twk-chip[data-on="1"]{box-shadow:0 0 0 1.5px rgba(0,0,0,.85),
    0 2px 6px rgba(0,0,0,.15)}
  .twk-chip>span{position:absolute;top:0;bottom:0;right:0;width:34%;
    display:flex;flex-direction:column;box-shadow:-1px 0 0 rgba(0,0,0,.1)}
  .twk-chip>span>i{flex:1;box-shadow:0 -1px 0 rgba(0,0,0,.1)}
  .twk-chip>span>i:first-child{box-shadow:none}
  .twk-chip svg{position:absolute;top:6px;left:6px;width:13px;height:13px;
    filter:drop-shadow(0 1px 1px rgba(0,0,0,.3))}
`;

// ── useTweaks ───────────────────────────────────────────────────────────────
// Single source of truth for tweak values. setTweak persists via the host
// (__edit_mode_set_keys → host rewrites the EDITMODE block on disk).
function useTweaks(defaults) {
  const [values, setValues] = React.useState(defaults);
  // Accepts either setTweak('key', value) or setTweak({ key: value, ... }) so a
  // useState-style call doesn't write a "[object Object]" key into the persisted
  // JSON block.
  const setTweak = React.useCallback((keyOrEdits, val) => {
    const edits = typeof keyOrEdits === 'object' && keyOrEdits !== null ? keyOrEdits : {
      [keyOrEdits]: val
    };
    setValues(prev => ({
      ...prev,
      ...edits
    }));
    window.parent.postMessage({
      type: '__edit_mode_set_keys',
      edits
    }, '*');
    // Same-window signal so in-page listeners (deck-stage rail thumbnails)
    // can react — the parent message only reaches the host, not peers.
    window.dispatchEvent(new CustomEvent('tweakchange', {
      detail: edits
    }));
  }, []);
  return [values, setTweak];
}

// ── TweaksPanel ─────────────────────────────────────────────────────────────
// Floating shell. Registers the protocol listener BEFORE announcing
// availability — if the announce ran first, the host's activate could land
// before our handler exists and the toolbar toggle would silently no-op.
// The close button posts __edit_mode_dismissed so the host's toolbar toggle
// flips off in lockstep; the host echoes __deactivate_edit_mode back which
// is what actually hides the panel.
function TweaksPanel({
  title = 'Tweaks',
  children
}) {
  const [open, setOpen] = React.useState(false);
  const dragRef = React.useRef(null);
  const offsetRef = React.useRef({
    x: 16,
    y: 16
  });
  const PAD = 16;
  const clampToViewport = React.useCallback(() => {
    const panel = dragRef.current;
    if (!panel) return;
    const w = panel.offsetWidth,
      h = panel.offsetHeight;
    const maxRight = Math.max(PAD, window.innerWidth - w - PAD);
    const maxBottom = Math.max(PAD, window.innerHeight - h - PAD);
    offsetRef.current = {
      x: Math.min(maxRight, Math.max(PAD, offsetRef.current.x)),
      y: Math.min(maxBottom, Math.max(PAD, offsetRef.current.y))
    };
    panel.style.right = offsetRef.current.x + 'px';
    panel.style.bottom = offsetRef.current.y + 'px';
  }, []);
  React.useEffect(() => {
    if (!open) return;
    clampToViewport();
    if (typeof ResizeObserver === 'undefined') {
      window.addEventListener('resize', clampToViewport);
      return () => window.removeEventListener('resize', clampToViewport);
    }
    const ro = new ResizeObserver(clampToViewport);
    ro.observe(document.documentElement);
    return () => ro.disconnect();
  }, [open, clampToViewport]);
  React.useEffect(() => {
    const onMsg = e => {
      const t = e?.data?.type;
      if (t === '__activate_edit_mode') setOpen(true);else if (t === '__deactivate_edit_mode') setOpen(false);
    };
    window.addEventListener('message', onMsg);
    window.parent.postMessage({
      type: '__edit_mode_available'
    }, '*');
    return () => window.removeEventListener('message', onMsg);
  }, []);
  const dismiss = () => {
    setOpen(false);
    window.parent.postMessage({
      type: '__edit_mode_dismissed'
    }, '*');
  };
  const onDragStart = e => {
    const panel = dragRef.current;
    if (!panel) return;
    const r = panel.getBoundingClientRect();
    const sx = e.clientX,
      sy = e.clientY;
    const startRight = window.innerWidth - r.right;
    const startBottom = window.innerHeight - r.bottom;
    const move = ev => {
      offsetRef.current = {
        x: startRight - (ev.clientX - sx),
        y: startBottom - (ev.clientY - sy)
      };
      clampToViewport();
    };
    const up = () => {
      window.removeEventListener('mousemove', move);
      window.removeEventListener('mouseup', up);
    };
    window.addEventListener('mousemove', move);
    window.addEventListener('mouseup', up);
  };
  if (!open) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("style", null, __TWEAKS_STYLE), /*#__PURE__*/React.createElement("div", {
    ref: dragRef,
    className: "twk-panel",
    "data-omelette-chrome": "",
    style: {
      right: offsetRef.current.x,
      bottom: offsetRef.current.y
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "twk-hd",
    onMouseDown: onDragStart
  }, /*#__PURE__*/React.createElement("b", null, title), /*#__PURE__*/React.createElement("button", {
    className: "twk-x",
    "aria-label": "Close tweaks",
    onMouseDown: e => e.stopPropagation(),
    onClick: dismiss
  }, "\u2715")), /*#__PURE__*/React.createElement("div", {
    className: "twk-body"
  }, children)));
}

// ── Layout helpers ──────────────────────────────────────────────────────────

function TweakSection({
  label,
  children
}) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "twk-sect"
  }, label), children);
}
function TweakRow({
  label,
  value,
  children,
  inline = false
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: inline ? 'twk-row twk-row-h' : 'twk-row'
  }, /*#__PURE__*/React.createElement("div", {
    className: "twk-lbl"
  }, /*#__PURE__*/React.createElement("span", null, label), value != null && /*#__PURE__*/React.createElement("span", {
    className: "twk-val"
  }, value)), children);
}

// ── Controls ────────────────────────────────────────────────────────────────

function TweakSlider({
  label,
  value,
  min = 0,
  max = 100,
  step = 1,
  unit = '',
  onChange
}) {
  return /*#__PURE__*/React.createElement(TweakRow, {
    label: label,
    value: `${value}${unit}`
  }, /*#__PURE__*/React.createElement("input", {
    type: "range",
    className: "twk-slider",
    min: min,
    max: max,
    step: step,
    value: value,
    onChange: e => onChange(Number(e.target.value))
  }));
}
function TweakToggle({
  label,
  value,
  onChange
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "twk-row twk-row-h"
  }, /*#__PURE__*/React.createElement("div", {
    className: "twk-lbl"
  }, /*#__PURE__*/React.createElement("span", null, label)), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "twk-toggle",
    "data-on": value ? '1' : '0',
    role: "switch",
    "aria-checked": !!value,
    onClick: () => onChange(!value)
  }, /*#__PURE__*/React.createElement("i", null)));
}
function TweakRadio({
  label,
  value,
  options,
  onChange
}) {
  const trackRef = React.useRef(null);
  const [dragging, setDragging] = React.useState(false);
  // The active value is read by pointer-move handlers attached for the lifetime
  // of a drag — ref it so a stale closure doesn't fire onChange for every move.
  const valueRef = React.useRef(value);
  valueRef.current = value;

  // Segments wrap mid-word once per-segment width runs out. The track is
  // ~248px (280 panel − 28 body pad − 4 seg pad), each button loses 12px
  // to its own padding, and 11.5px system-ui averages ~6.3px/char — so 2
  // options fit ~16 chars each, 3 fit ~10. Past that (or >3 options), fall
  // back to a dropdown rather than wrap.
  const labelLen = o => String(typeof o === 'object' ? o.label : o).length;
  const maxLen = options.reduce((m, o) => Math.max(m, labelLen(o)), 0);
  const fitsAsSegments = maxLen <= ({
    2: 16,
    3: 10
  }[options.length] ?? 0);
  if (!fitsAsSegments) {
    // <select> emits strings — map back to the original option value so the
    // fallback stays type-preserving (numbers, booleans) like the segment path.
    const resolve = s => {
      const m = options.find(o => String(typeof o === 'object' ? o.value : o) === s);
      return m === undefined ? s : typeof m === 'object' ? m.value : m;
    };
    return /*#__PURE__*/React.createElement(TweakSelect, {
      label: label,
      value: value,
      options: options,
      onChange: s => onChange(resolve(s))
    });
  }
  const opts = options.map(o => typeof o === 'object' ? o : {
    value: o,
    label: o
  });
  const idx = Math.max(0, opts.findIndex(o => o.value === value));
  const n = opts.length;
  const segAt = clientX => {
    const r = trackRef.current.getBoundingClientRect();
    const inner = r.width - 4;
    const i = Math.floor((clientX - r.left - 2) / inner * n);
    return opts[Math.max(0, Math.min(n - 1, i))].value;
  };
  const onPointerDown = e => {
    setDragging(true);
    const v0 = segAt(e.clientX);
    if (v0 !== valueRef.current) onChange(v0);
    const move = ev => {
      if (!trackRef.current) return;
      const v = segAt(ev.clientX);
      if (v !== valueRef.current) onChange(v);
    };
    const up = () => {
      setDragging(false);
      window.removeEventListener('pointermove', move);
      window.removeEventListener('pointerup', up);
    };
    window.addEventListener('pointermove', move);
    window.addEventListener('pointerup', up);
  };
  return /*#__PURE__*/React.createElement(TweakRow, {
    label: label
  }, /*#__PURE__*/React.createElement("div", {
    ref: trackRef,
    role: "radiogroup",
    onPointerDown: onPointerDown,
    className: dragging ? 'twk-seg dragging' : 'twk-seg'
  }, /*#__PURE__*/React.createElement("div", {
    className: "twk-seg-thumb",
    style: {
      left: `calc(2px + ${idx} * (100% - 4px) / ${n})`,
      width: `calc((100% - 4px) / ${n})`
    }
  }), opts.map(o => /*#__PURE__*/React.createElement("button", {
    key: o.value,
    type: "button",
    role: "radio",
    "aria-checked": o.value === value
  }, o.label))));
}
function TweakSelect({
  label,
  value,
  options,
  onChange
}) {
  return /*#__PURE__*/React.createElement(TweakRow, {
    label: label
  }, /*#__PURE__*/React.createElement("select", {
    className: "twk-field",
    value: value,
    onChange: e => onChange(e.target.value)
  }, options.map(o => {
    const v = typeof o === 'object' ? o.value : o;
    const l = typeof o === 'object' ? o.label : o;
    return /*#__PURE__*/React.createElement("option", {
      key: v,
      value: v
    }, l);
  })));
}
function TweakText({
  label,
  value,
  placeholder,
  onChange
}) {
  return /*#__PURE__*/React.createElement(TweakRow, {
    label: label
  }, /*#__PURE__*/React.createElement("input", {
    className: "twk-field",
    type: "text",
    value: value,
    placeholder: placeholder,
    onChange: e => onChange(e.target.value)
  }));
}
function TweakNumber({
  label,
  value,
  min,
  max,
  step = 1,
  unit = '',
  onChange
}) {
  const clamp = n => {
    if (min != null && n < min) return min;
    if (max != null && n > max) return max;
    return n;
  };
  const startRef = React.useRef({
    x: 0,
    val: 0
  });
  const onScrubStart = e => {
    e.preventDefault();
    startRef.current = {
      x: e.clientX,
      val: value
    };
    const decimals = (String(step).split('.')[1] || '').length;
    const move = ev => {
      const dx = ev.clientX - startRef.current.x;
      const raw = startRef.current.val + dx * step;
      const snapped = Math.round(raw / step) * step;
      onChange(clamp(Number(snapped.toFixed(decimals))));
    };
    const up = () => {
      window.removeEventListener('pointermove', move);
      window.removeEventListener('pointerup', up);
    };
    window.addEventListener('pointermove', move);
    window.addEventListener('pointerup', up);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "twk-num"
  }, /*#__PURE__*/React.createElement("span", {
    className: "twk-num-lbl",
    onPointerDown: onScrubStart
  }, label), /*#__PURE__*/React.createElement("input", {
    type: "number",
    value: value,
    min: min,
    max: max,
    step: step,
    onChange: e => onChange(clamp(Number(e.target.value)))
  }), unit && /*#__PURE__*/React.createElement("span", {
    className: "twk-num-unit"
  }, unit));
}

// Relative-luminance contrast pick — checkmarks drawn over a swatch need to
// read on both #111 and #fafafa without per-option configuration. Hex input
// only (#rgb / #rrggbb); named or rgb()/hsl() colors fall through to "light".
function __twkIsLight(hex) {
  const h = String(hex).replace('#', '');
  const x = h.length === 3 ? h.replace(/./g, c => c + c) : h.padEnd(6, '0');
  const n = parseInt(x.slice(0, 6), 16);
  if (Number.isNaN(n)) return true;
  const r = n >> 16 & 255,
    g = n >> 8 & 255,
    b = n & 255;
  return r * 299 + g * 587 + b * 114 > 148000;
}
const __TwkCheck = ({
  light
}) => /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 14 14",
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3 7.2 5.8 10 11 4.2",
  fill: "none",
  strokeWidth: "2.2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  stroke: light ? 'rgba(0,0,0,.78)' : '#fff'
}));

// TweakColor — curated color/palette picker. Each option is either a single
// hex string or an array of 1-5 hex strings; the card adapts — a lone color
// renders solid, a palette renders colors[0] as the hero (left ~2/3) with the
// rest stacked in a sharp column on the right. onChange emits the
// option in the shape it was passed (string stays string, array stays array).
// Without options it falls back to the native color input for back-compat.
function TweakColor({
  label,
  value,
  options,
  onChange
}) {
  if (!options || !options.length) {
    return /*#__PURE__*/React.createElement("div", {
      className: "twk-row twk-row-h"
    }, /*#__PURE__*/React.createElement("div", {
      className: "twk-lbl"
    }, /*#__PURE__*/React.createElement("span", null, label)), /*#__PURE__*/React.createElement("input", {
      type: "color",
      className: "twk-swatch",
      value: value,
      onChange: e => onChange(e.target.value)
    }));
  }
  // Native <input type=color> emits lowercase hex per the HTML spec, so
  // compare case-insensitively. String() guards JSON.stringify(undefined),
  // which returns the primitive undefined (no .toLowerCase).
  const key = o => String(JSON.stringify(o)).toLowerCase();
  const cur = key(value);
  return /*#__PURE__*/React.createElement(TweakRow, {
    label: label
  }, /*#__PURE__*/React.createElement("div", {
    className: "twk-chips",
    role: "radiogroup"
  }, options.map((o, i) => {
    const colors = Array.isArray(o) ? o : [o];
    const [hero, ...rest] = colors;
    const sup = rest.slice(0, 4);
    const on = key(o) === cur;
    return /*#__PURE__*/React.createElement("button", {
      key: i,
      type: "button",
      className: "twk-chip",
      role: "radio",
      "aria-checked": on,
      "data-on": on ? '1' : '0',
      "aria-label": colors.join(', '),
      title: colors.join(' · '),
      style: {
        background: hero
      },
      onClick: () => onChange(o)
    }, sup.length > 0 && /*#__PURE__*/React.createElement("span", null, sup.map((c, j) => /*#__PURE__*/React.createElement("i", {
      key: j,
      style: {
        background: c
      }
    }))), on && /*#__PURE__*/React.createElement(__TwkCheck, {
      light: __twkIsLight(hero)
    }));
  })));
}
function TweakButton({
  label,
  onClick,
  secondary = false
}) {
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: secondary ? 'twk-btn secondary' : 'twk-btn',
    onClick: onClick
  }, label);
}
Object.assign(window, {
  useTweaks,
  TweaksPanel,
  TweakSection,
  TweakRow,
  TweakSlider,
  TweakToggle,
  TweakRadio,
  TweakSelect,
  TweakText,
  TweakNumber,
  TweakColor,
  TweakButton
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/mission-control/tweaks-panel.jsx", error: String((e && e.message) || e) }); }

__ds_ns.Badge = __ds_scope.Badge;

__ds_ns.Button = __ds_scope.Button;

__ds_ns.Card = __ds_scope.Card;

__ds_ns.Compass = __ds_scope.Compass;

__ds_ns.IconButton = __ds_scope.IconButton;

__ds_ns.Kicker = __ds_scope.Kicker;

__ds_ns.Logo = __ds_scope.Logo;

__ds_ns.StatusPill = __ds_scope.StatusPill;

__ds_ns.Tag = __ds_scope.Tag;

__ds_ns.ActivityItem = __ds_scope.ActivityItem;

__ds_ns.StatCard = __ds_scope.StatCard;

__ds_ns.Table = __ds_scope.Table;

__ds_ns.Dialog = __ds_scope.Dialog;

__ds_ns.ProgressBar = __ds_scope.ProgressBar;

__ds_ns.Spinner = __ds_scope.Spinner;

__ds_ns.Toast = __ds_scope.Toast;

__ds_ns.Tooltip = __ds_scope.Tooltip;

__ds_ns.Checkbox = __ds_scope.Checkbox;

__ds_ns.Input = __ds_scope.Input;

__ds_ns.Radio = __ds_scope.Radio;

__ds_ns.Select = __ds_scope.Select;

__ds_ns.Switch = __ds_scope.Switch;

__ds_ns.Textarea = __ds_scope.Textarea;

__ds_ns.Avatar = __ds_scope.Avatar;

__ds_ns.SidebarItem = __ds_scope.SidebarItem;

__ds_ns.Tabs = __ds_scope.Tabs;

})();
